function initCustomDev() {
  // Each init runs isolated: a missing element in one feature must never
  // prevent the remaining features from initializing.
  const inits = [
    customCookieBanner,
    customMenu,
    customStickyHeader,
    poopySticky,
    customMobileMenu,
    customSearch,
    scrollToTop,
    poopyCopyright,
    checkAddToCartButton,
    customProductPopups,
    customPopupWarranty,
    customPopupInsurance,
    customPopupAddon,
    customAddOns,
    customBuyButtonsFlow,
    customBuyButtonsFlow2,
    atcModalAccordion,
    customFreeItems,
    customMultipleVideoModal,
    customProductVideoModal,
    customVideoGalleryModal,
    customVideoIframeModal,
    customProductDetailNavigation,
    customDetectProductDetailSection,
    customThumbnailSlider,
    videoStoriesSlider,
    customVideoStoriesModal,
    customPlayVideoBlock,
    customTimer,
    customTimerBlackTop,
    customOpenCartDrawer,
    customAffiliateMenu,
    customSupportSlider,
    customProductLightbox,
    customVariantPicker,
    infoModal,
    entryModal,
    productInfoModal,
    uniqueKlarnaModal,
    uniqueSprayPayModal,
    fullpageModal,
    globalDeliveryPickerAndAddonsListPrices,
  ];
  inits.forEach(function (fn) {
    try {
      fn();
    } catch (err) {
      console.warn("[custom-dev] init failed:", fn.name, err);
    }
  });
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initCustomDev);
} else {
  initCustomDev();
}

function customCookieBanner() {
  const banner = document.querySelector('#shopify-pc__banner');
  if (banner) {
    banner.setAttribute('data-clarity-ignore', '');
    // console.log("Shopify cookie banner is now ignored by Clarity.");
  }
  
  if (Shopify && Shopify.designMode) {
    const dialog = document.querySelector(".shopify-pc__banner__dialog");
    if (dialog) {
        dialog.style.display = "none";
    }
    
    return;
  }
  
  function wrapButtonTextInSpan(buttonId) {
    const button = document.getElementById(buttonId);
    if (button && !button.querySelector("span")) {
      const text = button.textContent.trim();
      button.innerHTML = `<span>${text}</span>`;
    }
  }

  // Wrap immediately available button
  wrapButtonTextInSpan("shopify-pc__banner__btn-accept");

  // Watch for preference buttons after clicking "Voorkeuren beheren"
  const managePrefsBtn = document.getElementById(
    "shopify-pc__banner__btn-manage-prefs"
  );
  if (managePrefsBtn) {
    managePrefsBtn.addEventListener("click", () => {
      setTimeout(() => {
        wrapButtonTextInSpan("shopify-pc__prefs__header-accept");
        wrapButtonTextInSpan("shopify-pc__prefs__header-save");
      }, 100); // Delay to let the DOM update (adjust if needed)
    });
  }

  let cookieBanner = document.querySelector(".shopify-pc__banner__wrapper");
  if (cookieBanner && !document.querySelector(".shopify-pc__banner__copy")) {
    const body = document.querySelector(".shopify-pc__banner__body");
    const btns = document.querySelector(".shopify-pc__banner__btns");
    const wrapper = document.querySelector(".shopify-pc__banner__wrapper");

    // Exit early if elements are missing
    if (!body || !btns || !wrapper) {
      return;
    }

    // Create the new wrapper div for content
    const copyDiv = document.createElement("div");
    copyDiv.classList.add("shopify-pc__banner__copy");

    // Create the new wrapper div for the image
    const imageDiv = document.createElement("div");
    imageDiv.classList.add("shopify-pc__banner__image");

    // Create the image element
    const img = document.createElement("img");
    img.src =
      "https://cdn.shopify.com/s/files/1/0872/1068/8837/files/poopy_cookie.png?v=1743380141";
    img.alt = "Cookie Banner Image";

    // Append the image inside the image div
    imageDiv.appendChild(img);

    // Insert the copyDiv inside the main wrapper before body
    wrapper.insertBefore(copyDiv, body);

    // Move body and btns inside the new wrapper
    copyDiv.appendChild(body);
    copyDiv.appendChild(btns);

    // Insert imageDiv after copyDiv
    wrapper.appendChild(imageDiv);
  }
}

function customSearch() {
  const searchIcon = document.querySelector(".custom-search-icon");
  const searchModal = document.querySelector(".custom-search");
  const closeSearch = document.getElementById("closeSearch");
  const searchInput = document.getElementById("productSearch");
  const noResultsMessage = document.getElementById("noResultsMessage");
  const resultsWrapper = document.querySelector(".custom-search__results__wrapper");
  const resultsCount = document.querySelector(".custom-search__results__count");
  const searchField = document.querySelector(".custom-search__field");
  const searchResults = document.querySelector(".custom-search__results");

  const allResults = {
    products: [],
    blogs: [],
    collections: [],
    pages: [],
  };

  // Categorize results
  document.querySelectorAll(".custom-search__result__link").forEach(el => allResults.products.push(el));
  document.querySelectorAll(".custom-search__result__link__blog").forEach(el => allResults.blogs.push(el));
  document.querySelectorAll(".custom-search__result__link__collection").forEach(el => allResults.collections.push(el));
  document.querySelectorAll(".custom-search__result__link__page").forEach(el => allResults.pages.push(el));

  if (!searchIcon || !searchModal || !closeSearch || !searchInput || !resultsWrapper) {
    return;
  }

  // Initial transform setup
  searchModal.style.transform = "translateY(-100vh)";
  searchModal.style.transition = "transform 0.3s ease-in-out";
  searchModal.style.display = "none";

  // Prevent input in header from stealing focus
  searchIcon.addEventListener("mousedown", function (event) {
    event.preventDefault();
  });

  // Show search modal
  searchIcon.addEventListener("click", function () {
    searchModal.style.display = "block";
    requestAnimationFrame(() => {
      searchModal.style.transform = "translateY(0)";
    });
    document.body.style.overflow = "hidden";
    setTimeout(() => {
      searchInput.focus();
    }, 10);
  });

  // Close search modal
  function closeSearchModal() {
    searchModal.style.transform = "translateY(-100vh)";
    setTimeout(() => {
      searchModal.style.display = "none";
    }, 300);
    document.body.style.overflow = "";
    searchInput.value = "";
    resetSearch();
  }

  closeSearch.addEventListener("click", closeSearchModal);

  document.addEventListener("click", function (event) {
    if (
      !searchField.contains(event.target) &&
      !searchIcon.contains(event.target) &&
      !searchResults.contains(event.target)
    ) {
      closeSearchModal();
    }
  });

  document.addEventListener("keydown", function (event) {
    if (event.key === "Escape") {
      closeSearchModal();
    }
  });

  // Debounce function
  function debounce(func, delay) {
    let timer;
    return function (...args) {
      clearTimeout(timer);
      timer = setTimeout(() => func.apply(this, args), delay);
    };
  }

  // Extract keywords
  function extractKeywords(query) {
    return query.split(/\s+/).filter(word => word.length > 0);
  }

  // Perform search
  function performSearch() {
    const query = searchInput.value.toLowerCase().trim();
    if (query === "") {
      resetSearch();
      return;
    }

    const keywords = extractKeywords(query);
    let matches = 0;

    if (keywords.some(word => ["blog", "article", "blogpost", "artikel"].includes(word))) {
      resultsWrapper.innerHTML = "";
      allResults.blogs.forEach(item => resultsWrapper.appendChild(item));
      matches = allResults.blogs.length;
    } else if (
      keywords.some(word =>
        [
          "contact", "help", "email", "phone", "video", "faq", "manual",
          "app", "instruction", "instruction video", "address", "info", "ondersteuning",
          "hulp", "telefoon", "handleiding", "adres", "veelgestelde vragen",
          "instructie", "instructievideo", "e-mail"
        ].includes(word)
      )
    ) {
      resultsWrapper.innerHTML = `<a href="/pages/support" class="custom-search__result__link__page">
        <div class="custom-search__result__image__page" style="background-color: #ffffff;">
          <img src="https://cdn.shopify.com/s/files/1/0872/1068/8837/files/poopy_homepage_banner.webp?v=1741072221" alt="Support">
        </div>
        <h2 class="custom-search__result__title__page museo-medium">Support</h2>
      </a>`;
      matches = 1;
    } else if (keywords.some(word => ["product", "shop", "winkel"].includes(word))) {
      resultsWrapper.innerHTML = "";
      allResults.products.forEach(item => resultsWrapper.appendChild(item));
      matches = allResults.products.length;
    } else if (
      keywords.some(word =>
        ["collection", "category", "categories", "collectie", "categorie", "categorieen", "categorieën"].includes(word)
      )
    ) {
      resultsWrapper.innerHTML = "";
      allResults.collections.forEach(item => resultsWrapper.appendChild(item));
      matches = allResults.collections.length;
    } else if (keywords.some(word => ["page", "pagina"].includes(word))) {
      resultsWrapper.innerHTML = "";
      allResults.pages.forEach(item => resultsWrapper.appendChild(item));
      matches = allResults.pages.length;
    } else {
      function filterAndSort(category) {
        return allResults[category]
          .map(item => {
            const title = item.querySelector("h2").textContent.toLowerCase();
            const keywordMatches = keywords.filter(kw => title.includes(kw)).length;
            return { element: item, title, keywordMatches };
          })
          .filter(item => item.keywordMatches > 0)
          .sort((a, b) =>
            b.keywordMatches - a.keywordMatches ||
            a.title.localeCompare(b.title)
          )
          .map(item => item.element);
      }

      resultsWrapper.innerHTML = "";
      ["products", "blogs", "collections", "pages"].forEach(category => {
        const sortedResults = filterAndSort(category);
        sortedResults.forEach(item => resultsWrapper.appendChild(item));
        matches += sortedResults.length;
      });
    }

    resultsWrapper.style.display = matches > 0 ? "flex" : "none";
    resultsCount.style.display = matches > 0 ? "block" : "none";
    resultsCount.innerHTML = `Resultaten (${matches})`;

    noResultsMessage.style.display = matches === 0 ? "block" : "none";
    noResultsMessage.innerHTML = matches === 0
      ? `Uw zoekopdracht naar <strong>"${query}"</strong> heeft geen resultaten opgeleverd.`
      : "";
  }

  searchInput.addEventListener("keyup", debounce(performSearch, 300));

  function resetSearch() {
    resultsWrapper.innerHTML = "";
    resultsWrapper.style.display = "none";
    noResultsMessage.style.display = "none";
    resultsCount.style.display = "none";
  }

  // Show the trigger only when everything is ready
  searchIcon.style.display = "flex";
}

function customStickyHeader() {
  const header = document.querySelector(
    "#shopify-section-sections--22441929802053__header"
  );

  if (!header) {
    return;
  }

  let lastScrollY = window.scrollY;
  let isVisible = false;
  let animationFrame;

  function isMobile() {
    return window.innerWidth <= 768; // Disable on mobile screens
  }

  function handleScroll() {
    if (isMobile()) return; // Prevent function from running on mobile

    const currentScrollY = window.scrollY;

    if (currentScrollY < lastScrollY) {
      // Scrolling up - Show header smoothly
      if (!isVisible) {
        animateHeader(52, 0.2); // Slide down to 52px (smooth speed)
        isVisible = true;
      }
    } else {
      // Scrolling down - Hide header slowly
      if (isVisible) {
        animateHeader(-100, 0.05); // Slide up more gradually
        isVisible = false;
      }
    }

    lastScrollY = currentScrollY;
  }

  function animateHeader(targetTop, speed) {
    cancelAnimationFrame(animationFrame);

    function step() {
      let currentTop = parseFloat(header.style.top || "-100");
      let delta = (targetTop - currentTop) * speed; // Adjust animation speed
      if (Math.abs(delta) < 1) {
        header.style.top = `${targetTop}px`;
        return;
      }
      header.style.top = `${currentTop + delta}px`;
      animationFrame = requestAnimationFrame(step);
    }

    step();
  }

  // Set initial style
  header.style.top = "-100px"; // Initially hidden

  window.addEventListener("scroll", handleScroll);
}

function checkAddToCartButton() {
  const button = document.querySelector("[id^='ProductSubmitButton']");
  const stickyBar = document.querySelector(".custom-sticky-add-to-cart");
  const scrollTopBtn = document.querySelector(".scroll-top-btn");
  const footer = document.querySelector("footer");
  const liveChat = document.querySelector(".poopy-live-chat");

  // Still allow scrollTopBtn and liveChat positioning logic to run even if some elements are missing
  if (!scrollTopBtn || !footer) {
    return;
  }

  const originalScrollTopBottom = getComputedStyle(scrollTopBtn).bottom;

  function toggleStickyBar() {
    let showSticky = false;

    if (button && stickyBar) {
      const buttonRect = button.getBoundingClientRect();
      const footerRect = footer.getBoundingClientRect();
      const isButtonVisible =
        buttonRect.top < window.innerHeight && buttonRect.bottom >= 0;
      const isFooterVisible =
        footerRect.top < window.innerHeight && footerRect.bottom >= 0;

      showSticky = !(isButtonVisible || isFooterVisible);

      if (showSticky) {
        stickyBar.classList.add("show-sticky-bar");
        scrollTopBtn.style.bottom = "110px";
      } else {
        stickyBar.classList.remove("show-sticky-bar");
        scrollTopBtn.style.bottom = originalScrollTopBottom;
      }
    }

    // ✅ Live chat repositioning logic (mobile only)
    if (liveChat && window.innerWidth <= 768) {
      const scrollBtnVisible = scrollTopBtn.classList.contains("show");
      const stickyVisible = stickyBar?.classList.contains("show-sticky-bar");

      if (stickyVisible && scrollBtnVisible) {
        liveChat.style.bottom = "155px";
      } else if (stickyVisible) {
        liveChat.style.bottom = "110px";
      } else if (scrollBtnVisible) {
        liveChat.style.bottom = "85px";
      } else {
        liveChat.style.bottom = "40px";
      }
    }
  }

  toggleStickyBar();

  if (button && footer) {
    const observer = new IntersectionObserver(
      () => {
        toggleStickyBar();
      },
      { threshold: 1.0 }
    );

    observer.observe(button);
    observer.observe(footer);
  }

  window.addEventListener("scroll", toggleStickyBar);
  window.addEventListener("resize", toggleStickyBar);
}

function scrollToTop() {
  const scrollTopBtn = document.getElementById("scrollTopBtn");
  if (!scrollTopBtn) return; // button not on this page

  window.addEventListener("scroll", function () {
    if (window.scrollY > 300) {
      // Adjust this value if needed
      scrollTopBtn.classList.add("show");
    } else {
      scrollTopBtn.classList.remove("show");
    }
  });

  scrollTopBtn.addEventListener("click", function () {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  });
}

function infoModal() {
  // Get references to modal elements
  const infoOpenModalButtons = document.querySelectorAll(".info-modal-trigger");
  const infoCloseModalButton = document.getElementById("infoCloseModal");
  const infoModalOverlay = document.getElementById("infoModalOverlay");
  const infoModalImage = document.getElementById("infoModalImage");
  const infoModalTitle = document.getElementById("infoModalTitle");
  const infoModalDescription = document.getElementById("infoModalDescription");

  // Modal markup not present on this page
  if (!infoCloseModalButton || !infoModalOverlay) return;

  // Function to open modal and disable scrolling
  function openModal(button) {
    // Retrieve content from data attributes
    const imageSrc = button.getAttribute("data-info-info-image");
    const title = button.getAttribute("data-info-info-title");
    const description = button.getAttribute("data-info-info-desc");
    const titleFontClass = button.getAttribute("data-info-info-title-font");
    const titleFontSize = button.getAttribute("data-info-info-title-size");
    const descFontClass = button.getAttribute("data-info-info-desc-font");
    const descFontSize = button.getAttribute("data-info-info-desc-size");

    // Update modal content
    infoModalImage.src = imageSrc || "";
    infoModalTitle.textContent = title || "";
    infoModalDescription.innerHTML = description || "";

    // Apply dynamic font class and size to title
    infoModalTitle.className = titleFontClass
      ? `info-modal__text-title ${titleFontClass}`
      : "info-modal__text-title";
    infoModalTitle.style.fontSize = titleFontSize || "";

    // Apply dynamic font class and size to description
    infoModalDescription.className = descFontClass
      ? `info-modal__text-description ${descFontClass}`
      : "info-modal__text-description";
    infoModalDescription.style.fontSize = descFontSize || "";

    // Display the modal and disable scrolling
    infoModalOverlay.style.display = "block";
    document.body.style.overflow = "hidden";

    // Add event listener for Escape key
    document.addEventListener("keydown", handleEscKey);
  }

  // Function to close modal and enable scrolling
  function closeModal() {
    infoModalOverlay.style.display = "none";
    document.body.style.overflow = ""; // Reset scrolling

    // Remove event listener for Escape key
    document.removeEventListener("keydown", handleEscKey);
  }

  // Function to handle Escape key press
  function handleEscKey(event) {
    if (event.key === "Escape") {
      closeModal();
    }
  }

  // Attach event listener to each trigger
  infoOpenModalButtons.forEach((button) => {
    button.addEventListener("click", () => openModal(button));
  });

  // Close modal when clicking the close button
  infoCloseModalButton.addEventListener("click", closeModal);

  // Close modal when clicking outside of the modal content
  infoModalOverlay.addEventListener("click", (e) => {
    if (e.target === infoModalOverlay) {
      closeModal();
    }
  });
}

function entryModal() {
  const overlay = document.querySelector('.entry-modal_overlay');
  const container = document.querySelector('.entry-modal_container');
  const closeBtn = document.querySelector('.entry-modal_close');

  if (!overlay || !container || !closeBtn) return;

  const SESSION_KEY = 'entryPopupShown';

  // Initial hidden state (JS only)
  overlay.style.display = 'none';
  overlay.style.opacity = '0';
  overlay.style.transition = 'opacity 0.3s ease';

  container.style.transform = 'scale(0.95)';
  container.style.opacity = '0';
  container.style.transition = 'transform 0.3s ease, opacity 0.3s ease';

  function disableScroll() {
    document.body.style.overflow = 'hidden';
  }

  function enableScroll() {
    document.body.style.overflow = '';
  }

  function openModal() {
    overlay.style.display = 'flex';
    disableScroll();

    // Trigger animation
    requestAnimationFrame(() => {
      overlay.style.opacity = '1';
      container.style.transform = 'scale(1)';
      container.style.opacity = '1';
    });
  }

  function closeModal() {
    overlay.style.opacity = '0';
    container.style.transform = 'scale(0.95)';
    container.style.opacity = '0';

    setTimeout(() => {
      overlay.style.display = 'none';
      enableScroll();
    }, 300);
  }

  // Show once per session after 2 seconds
  if (!sessionStorage.getItem(SESSION_KEY)) {
    setTimeout(() => {
      openModal();
      sessionStorage.setItem(SESSION_KEY, 'true');
    }, 2000);
  }

  // Close button
  closeBtn.addEventListener('click', closeModal);

  // Optional: click outside to close
  overlay.addEventListener('click', function (e) {
    if (e.target === overlay) {
      closeModal();
    }
  });
}

function productInfoModal() {
  const openButtons = document.querySelectorAll(".product-info-modal-trigger");
  const modal = document.querySelector(".product-info-modal");
  if (!modal || !openButtons.length) return; // page has no product info modal
  const modalContainer = modal.querySelector(".product-info-modal_container");
  const closeButton = modal.querySelector(".product-info-modal_container_close");
  const modalTitle = modal.querySelector(".product-info-modal_container_content_title h3");
  const modalImage = modal.querySelector(".product-info-modal_container_content_image img");
  const modalDescription = modal.querySelector(".product-info-modal_container_content_description p");

  const modalContent = modal.querySelector(".product-info-modal_container_content");

  // Transition settings
  modalContent.style.transition = "transform 0.3s ease-in-out";
  closeButton.style.opacity = "0";
  closeButton.style.transition = "opacity 0.3s ease-in-out";

  // Helper: get direction based on screen size
  function getClosedTransform() {
    if (window.innerWidth <= 768) {
      // Mobile → slide from bottom
      return "translateY(100%)";
    } else {
      // Desktop → slide from right
      return "translateX(100%)";
    }
  }

  // Initialize
  modalContent.style.transform = getClosedTransform();

  function openModal(button) {
    const title = button.getAttribute("data-product-info-title");
    const imageSrc = button.getAttribute("data-product-info-image");
    const description = button.getAttribute("data-product-info-desc");

    if (title) modalTitle.textContent = title;
    if (imageSrc) modalImage.src = imageSrc;
    if (description) modalDescription.innerHTML = description;

    modal.style.display = "block";
    document.body.style.overflow = "hidden";
    document.documentElement.style.overflow = "hidden";

    // force reflow so transitions trigger
    void modalContent.offsetWidth;

    // Slide in + show close button
    modalContent.style.transform = "translateX(0%)";
    if (window.innerWidth <= 768) {
      modalContent.style.transform = "translateY(0%)";
    }
    closeButton.style.opacity = "1";

    document.addEventListener("keydown", handleEscKey);
  }

  function closeModal() {
    // Slide out + hide close button
    modalContent.style.transform = getClosedTransform();
    closeButton.style.opacity = "0";

    modalContent.addEventListener(
      "transitionend",
      function handler() {
        modal.style.display = "none";
        document.body.style.overflow = "";
        document.documentElement.style.overflow = "";   
        modalContent.removeEventListener("transitionend", handler);
      }
    );

    document.removeEventListener("keydown", handleEscKey);
  }

  function handleEscKey(event) {
    if (event.key === "Escape") {
      closeModal();
    }
  }

  openButtons.forEach((button) => {
    button.addEventListener("click", () => openModal(button));
  });

  closeButton.addEventListener("click", closeModal);

  modal.addEventListener("click", (e) => {
    if (e.target === modal) {
      closeModal();
    }
  });

  // Recalculate when resizing (desktop ↔ mobile)
  window.addEventListener("resize", () => {
    if (modal.style.display === "none" || !modal.style.display) {
      modalContent.style.transform = getClosedTransform();
    }
  });
}

function uniqueKlarnaModal() {
  const klarnaOpenModalButtons = document.querySelectorAll(".klarna-popup-trigger");
  const klarnaCloseModalButton = document.querySelector(".klarna-close-icon");
  const klarnaModalOverlay = document.querySelector(".klarna-modal-overlay");
  const footerCloseButton = document.querySelector(".klarna-modal__footer .poopy-button");

  // Identifiers
  const klarnaModalLogo = document.getElementById("modalLogo");
  const klarnaModalHeader = document.getElementById("modalHeader");
  const klarnaModalSubheader = document.getElementById("modalSubheader");
  const klarnaModalPaymentMethodPrice1 = document.getElementById("modalPaymentMethodPrice1");
  const klarnaModalPaymentMethodInfo1 = document.getElementById("modalPaymentMethodInfo1");
  const klarnaModalPaymentMethodBadge1 = document.getElementById("modalPaymentMethodBadge1");
  const klarnaModalPaymentMethodPrice2 = document.getElementById("modalPaymentMethodPrice2");
  const klarnaModalPaymentMethodInfo2 = document.getElementById("modalPaymentMethodInfo2");
  const klarnaModalPaymentMethodBadge2 = document.getElementById("modalPaymentMethodBadge2");
  const klarnaModalPaymentMethodPrice3 = document.getElementById("modalPaymentMethodPrice3");
  const klarnaModalPaymentMethodInfo3 = document.getElementById("modalPaymentMethodInfo3");
  const klarnaModalPaymentMethodBadge3 = document.getElementById("modalPaymentMethodBadge3");
  const klarnaModalProgressStepSvg1 = document.getElementById("modalProgressStepSvg1");
  const klarnaModalProgressStepPrice1 = document.getElementById("modalProgressStepPrice1");
  const klarnaModalProgressStepInfo1 = document.getElementById("modalProgressStepInfo1");
  const klarnaModalProgressStepSvg2 = document.getElementById("modalProgressStepSvg2");
  const klarnaModalProgressStepPrice2 = document.getElementById("modalProgressStepPrice2");
  const klarnaModalProgressStepInfo2 = document.getElementById("modalProgressStepInfo2");
  const klarnaModalProgressStepSvg3 = document.getElementById("modalProgressStepSvg3");
  const klarnaModalProgressStepPrice3 = document.getElementById("modalProgressStepPrice3");
  const klarnaModalProgressStepInfo3 = document.getElementById("modalProgressStepInfo3");
  const klarnaModalTerms = document.getElementById("modalTerms");
  const klarnaModalListHeader = document.getElementById("modalListHeader");
  const klarnaModalListItemHeader1 = document.getElementById("modalListItemHeader1");
  const klarnaModalListItemDescription1 = document.getElementById("modalListItemDescription1");
  const klarnaModalListItemHeader2 = document.getElementById("modalListItemHeader2");
  const klarnaModalListItemDescription2 = document.getElementById("modalListItemDescription2");
  const klarnaModalListItemHeader3 = document.getElementById("modalListItemHeader3");
  const klarnaModalListItemDescription3 = document.getElementById("modalListItemDescription3");
  const klarnaModalFooterButtonText = document.getElementById("modalFooterButtonText");

  function openModal(button) {
    if (!klarnaModalOverlay) return;

    // Get data from button
    const get = (attr) => button.getAttribute(attr) || "";

    if (klarnaModalLogo) klarnaModalLogo.src = get("data-klarna-popup-logo");
    if (klarnaModalHeader) klarnaModalHeader.textContent = get("data-klarna-popup-header");
    if (klarnaModalSubheader) klarnaModalSubheader.innerHTML = get("data-klarna-popup-subheader");
    if (klarnaModalPaymentMethodPrice1) klarnaModalPaymentMethodPrice1.textContent = get("data-klarna-popup-payment-method-price-1");
    if (klarnaModalPaymentMethodInfo1) klarnaModalPaymentMethodInfo1.textContent = get("data-klarna-popup-payment-method-info-1");
    if (klarnaModalPaymentMethodBadge1) klarnaModalPaymentMethodBadge1.textContent = get("data-klarna-popup-payment-method-badge-1");
    if (klarnaModalPaymentMethodPrice2) klarnaModalPaymentMethodPrice2.textContent = get("data-klarna-popup-payment-method-price-2");
    if (klarnaModalPaymentMethodInfo2) klarnaModalPaymentMethodInfo2.textContent = get("data-klarna-popup-payment-method-info-2");
    if (klarnaModalPaymentMethodBadge2) klarnaModalPaymentMethodBadge2.textContent = get("data-klarna-popup-payment-method-badge-2");
    if (klarnaModalPaymentMethodPrice3) klarnaModalPaymentMethodPrice3.textContent = get("data-klarna-popup-payment-method-price-3");
    if (klarnaModalPaymentMethodInfo3) klarnaModalPaymentMethodInfo3.textContent = get("data-klarna-popup-payment-method-info-3");
    if (klarnaModalPaymentMethodBadge3) klarnaModalPaymentMethodBadge3.textContent = get("data-klarna-popup-payment-method-badge-3");
    if (klarnaModalProgressStepSvg1) klarnaModalProgressStepSvg1.innerHTML = get("data-klarna-popup-progress-step-svg-1");
    if (klarnaModalProgressStepPrice1) klarnaModalProgressStepPrice1.textContent = get("data-klarna-popup-progress-step-price-1");
    if (klarnaModalProgressStepInfo1) klarnaModalProgressStepInfo1.textContent = get("data-klarna-popup-progress-step-info-1");
    if (klarnaModalProgressStepSvg2) klarnaModalProgressStepSvg2.innerHTML = get("data-klarna-popup-progress-step-svg-2");
    if (klarnaModalProgressStepPrice2) klarnaModalProgressStepPrice2.textContent = get("data-klarna-popup-progress-step-price-2");
    if (klarnaModalProgressStepInfo2) klarnaModalProgressStepInfo2.textContent = get("data-klarna-popup-progress-step-info-2");
    if (klarnaModalProgressStepSvg3) klarnaModalProgressStepSvg3.innerHTML = get("data-klarna-popup-progress-step-svg-3");
    if (klarnaModalProgressStepPrice3) klarnaModalProgressStepPrice3.textContent = get("data-klarna-popup-progress-step-price-3");
    if (klarnaModalProgressStepInfo3) klarnaModalProgressStepInfo3.textContent = get("data-klarna-popup-progress-step-info-3");
    if (klarnaModalTerms) klarnaModalTerms.innerHTML = get("data-klarna-popup-terms");
    if (klarnaModalListHeader) klarnaModalListHeader.textContent = get("data-klarna-popup-list-header");
    if (klarnaModalListItemHeader1) klarnaModalListItemHeader1.textContent = get("data-klarna-popup-list-item-header-1");
    if (klarnaModalListItemDescription1) klarnaModalListItemDescription1.innerHTML = get("data-klarna-popup-list-item-description-1");
    if (klarnaModalListItemHeader2) klarnaModalListItemHeader2.textContent = get("data-klarna-popup-list-item-header-2");
    if (klarnaModalListItemDescription2) klarnaModalListItemDescription2.innerHTML = get("data-klarna-popup-list-item-description-2");
    if (klarnaModalListItemHeader3) klarnaModalListItemHeader3.textContent = get("data-klarna-popup-list-item-header-3");
    if (klarnaModalListItemDescription3) klarnaModalListItemDescription3.innerHTML = get("data-klarna-popup-list-item-description-3");
    if (klarnaModalFooterButtonText) klarnaModalFooterButtonText.textContent = get("data-klarna-popup-button-text");

    klarnaModalOverlay.style.display = "block";
    document.addEventListener("keydown", handleEscKey);
  }

  function closeModal() {
    if (klarnaModalOverlay) {
      klarnaModalOverlay.style.display = "none";
      document.removeEventListener("keydown", handleEscKey);
    }
  }

  function handleEscKey(event) {
    if (event.key === "Escape") {
      closeModal();
    }
  }

  // Attach open listeners
  if (klarnaOpenModalButtons.length) {
    klarnaOpenModalButtons.forEach((button) => {
      button.addEventListener("click", () => openModal(button));
    });
  }

  // Attach close listeners with safety checks
  if (klarnaCloseModalButton) {
    klarnaCloseModalButton.addEventListener("click", closeModal);
  }

  if (footerCloseButton) {
    footerCloseButton.addEventListener("click", closeModal);
  }

  if (klarnaModalOverlay) {
    klarnaModalOverlay.addEventListener("click", (e) => {
      if (e.target === klarnaModalOverlay) {
        closeModal();
      }
    });
  }
}

function uniqueSprayPayModal() {
  const spraypayOpenModalButtons = document.querySelectorAll(".spraypay-popup-trigger");
  const spraypayCloseModalButton = document.querySelector(".spraypay-close-icon");
  const spraypayModalOverlay = document.querySelector(".spraypay-modal-overlay");

  // Identifiers
  const spraypayModalLogo = document.getElementById("spraypayModalLogo");
  const spraypayModalHeader = document.getElementById("spraypayModalHeader");
  const spraypayModalSubheader = document.getElementById("spraypayModalSubheader");

  function openModal(button) {
    if (!spraypayModalOverlay) return;

    // Get data from button
    const get = (attr) => button.getAttribute(attr) || "";

    if (spraypayModalLogo) spraypayModalLogo.src = get("data-spraypay-popup-logo");
    if (spraypayModalHeader) spraypayModalHeader.textContent = get("data-spraypay-popup-header");
    if (spraypayModalSubheader) spraypayModalSubheader.innerHTML = get("data-spraypay-popup-subheader");

    spraypayModalOverlay.style.display = "block";
    document.addEventListener("keydown", handleEscKey);
  }

  function closeModal() {
    if (spraypayModalOverlay) {
      spraypayModalOverlay.style.display = "none";
      document.removeEventListener("keydown", handleEscKey);
    }
  }

  function handleEscKey(event) {
    if (event.key === "Escape") {
      closeModal();
    }
  }

  // Attach open listeners
  if (spraypayOpenModalButtons.length) {
    spraypayOpenModalButtons.forEach((button) => {
      button.addEventListener("click", () => openModal(button));
    });
  }

  // Attach close listeners with safety checks
  if (spraypayCloseModalButton) {
    spraypayCloseModalButton.addEventListener("click", closeModal);
  }

  if (spraypayModalOverlay) {
    spraypayModalOverlay.addEventListener("click", (e) => {
      if (e.target === spraypayModalOverlay) {
        closeModal();
      }
    });
  }
}

function fullpageModal() {
  const fullModal = document.querySelector(".fullpage-modal");
  const fullTriggers = document.querySelectorAll(".fullpage-modal-trigger");
  const fullCloseBtn = document.querySelector(".fullpage-modal-container-close");
  const fullProduct = document.querySelector(".fullpage-modal-container-product");

  if (!fullModal) return;

  fullModal.style.display = "none";

  let modalOpenedManually = false; // track if user clicked

  function animateProduct() {
    const duration = 1200; // slower animation
    const start = performance.now();
    const initialRight = -400; 
    const finalRight = 0;

    function frame(time) {
      const progress = Math.min((time - start) / duration, 1);
      const ease = 1 - Math.pow(1 - progress, 3); // ease-out

      fullProduct.style.right = initialRight + (finalRight - initialRight) * ease + "px";
      fullProduct.style.opacity = ease;

      if (progress < 1) {
        requestAnimationFrame(frame);
      }
    }

    fullProduct.style.right = initialRight + "px";
    fullProduct.style.opacity = 0;
    requestAnimationFrame(frame);
  }

  function fullOpenModal() {
    fullModal.style.display = "flex";
    document.body.style.overflow = "hidden";

    if (fullProduct) {
      animateProduct();
    }
  }

  function fullCloseModal() {
    fullModal.style.display = "none";
    document.body.style.overflow = "";
  }

  // Trigger click opens modal and cancels auto-show
  fullTriggers.forEach(fullTrigger => {
    fullTrigger.addEventListener("click", () => {
      modalOpenedManually = true; // mark as manually opened
      fullOpenModal();
    });
  });

  if (fullCloseBtn) {
    fullCloseBtn.addEventListener("click", fullCloseModal);
  }

  fullModal.addEventListener("click", function(e) {
    if (e.target === fullModal) {
      fullCloseModal();
    }
  });

  // Auto-show modal after 5s if user hasn't clicked
  setTimeout(() => {
    if (!modalOpenedManually) {
      fullOpenModal();
    }
  }, 5000);
}

function poopySticky() {
  const announcementBars = document.querySelectorAll(
    ".announcement-bar-section"
  );

  if (announcementBars.length > 0) {
    // Create a wrapper div
    const wrapper = document.createElement("div");
    wrapper.classList.add("announcement-bar-wrapper", "poopy-sticky");

    // Insert the wrapper before the first announcement bar
    announcementBars[0].parentNode.insertBefore(wrapper, announcementBars[0]);

    // Move each announcement bar inside the wrapper
    announcementBars.forEach((bar) => {
      wrapper.appendChild(bar);
    });
  }
}

function customSupportSlider() {
  const wrapper = document.querySelector(".custom-support-slider__wrapper");
  const items = document.querySelectorAll(".custom-support-slider__item");
  const nextButton = document.querySelector(".next");
  const prevButton = document.querySelector(".prev");
  const links = document.querySelectorAll(".custom-support-slider__item-link");

  let currentIndex = 0;
  let isDragging = false;
  let startX, currentX;
  let isSwipe = false; // Flag to detect swipe
  let dragThreshold = 10; // Distance threshold to determine if it's a drag/swipe or click

  // Ensure items are available before proceeding
  if (items.length === 0) {
    // console.error("No items found in the slider.");
    return; // Exit if no items are found
  }

  // Calculate item width
  const itemWidth = items[0].offsetWidth + 32; // Include margin or gap

  // Function to update slider position
  function updateSliderPosition() {
    const newTransformValue = -currentIndex * itemWidth;
    wrapper.style.transform = `translateX(${newTransformValue}px)`;
    toggleButtonStates(); // Update buttons state
  }

  // Function to toggle prev/next button states
  function toggleButtonStates() {
    prevButton.classList.toggle("disabled", currentIndex === 0);
    nextButton.classList.toggle("disabled", currentIndex === items.length - 1);
  }

  // Event listeners for buttons
  nextButton.addEventListener("click", () => {
    if (currentIndex < items.length - 1) {
      currentIndex++;
      updateSliderPosition();
    }
  });

  prevButton.addEventListener("click", () => {
    if (currentIndex > 0) {
      currentIndex--;
      updateSliderPosition();
    }
  });

  // Function to handle drag/swipe logic
  function handleDragSwipe(event, isTouchEvent = false) {
    if (!isDragging) return;
    currentX = isTouchEvent ? event.touches[0].pageX : event.pageX;
    const diffX = currentX - startX;

    if (Math.abs(diffX) > dragThreshold) {
      isSwipe = true; // Set swipe flag if drag/swipe detected
    }

    if (diffX < -100 && currentIndex < items.length - 1) {
      currentIndex++;
      updateSliderPosition();
      isDragging = false;
    } else if (diffX > 100 && currentIndex > 0) {
      currentIndex--;
      updateSliderPosition();
      isDragging = false;
    }
  }

  // Handle drag/swipe start (mouse)
  wrapper.addEventListener("mousedown", (event) => {
    isDragging = true;
    startX = event.pageX;
    isSwipe = false; // Reset swipe flag
    event.preventDefault(); // Prevent default action (text selection, etc.)
  });

  // Handle drag/swipe movement (mouse)
  wrapper.addEventListener("mousemove", (event) => handleDragSwipe(event));

  // Handle drag/swipe end (mouse)
  wrapper.addEventListener("mouseup", () => {
    isDragging = false;
  });

  // Handle drag/swipe start (touch)
  wrapper.addEventListener("touchstart", (event) => {
    isDragging = true;
    startX = event.touches[0].pageX;
    isSwipe = false; // Reset swipe flag
    event.preventDefault(); // Prevent default action (scrolling, etc.)
  });

  // Handle drag/swipe movement (touch)
  wrapper.addEventListener("touchmove", (event) =>
    handleDragSwipe(event, true)
  );

  // Handle drag/swipe end (touch)
  wrapper.addEventListener("touchend", () => {
    isDragging = false;
  });

  // Prevent anchor click only if swipe was detected
  links.forEach((link) => {
    link.addEventListener("click", (event) => {
      if (isSwipe) {
        event.preventDefault(); // Disable link click if swipe occurred
      }
    });
  });

  // Initial call to update button states
  toggleButtonStates();
}

function customAffiliateMenu() {
  const navLinks = document.querySelectorAll(".custom-affiliate-navigation a");

  navLinks.forEach((link) => {
    link.addEventListener("click", function (event) {
      // Prevent default anchor click behavior
      event.preventDefault();

      // Remove 'active' class from all links
      navLinks.forEach((nav) => nav.classList.remove("active"));

      // Add 'active' class to the clicked link
      this.classList.add("active");

      // Get the target section ID from the link's href attribute
      const targetId = this.getAttribute("href");
      const targetSection = document.querySelector(targetId);

      // Smooth scroll to the target section with an offset
      if (targetSection) {
        const offset = 100; // Adjust this value as needed for your fixed header
        const targetPosition =
          targetSection.getBoundingClientRect().top + window.scrollY - offset;

        window.scrollTo({
          top: targetPosition,
          behavior: "smooth",
        });
      }
    });

    // Add hover event listeners for hovered class
    link.addEventListener("mouseenter", function () {
      this.classList.add("hovered");
    });

    link.addEventListener("mouseleave", function () {
      this.classList.remove("hovered");
    });
  });
}

function poopyCopyright() {
  // Disable Right-Click and Image Download
  document.addEventListener("contextmenu", function (event) {
    event.preventDefault();
  });

  // Disable Text Copying
  document.addEventListener("copy", function (event) {
    event.clipboardData.setData("text/plain", "Copying is not allowed");
    event.preventDefault();
  });
}

function customMenu() {
  const items = document.querySelectorAll(".header__inline-menu details");

  items.forEach((item) => {
    const ul = item.querySelector("ul");

    const closeItem = () => {
      item.removeAttribute("open");
    };

    item.addEventListener("mouseover", () => {
      item.setAttribute("open", true);
    });

    item.addEventListener("mouseleave", closeItem);
    if (ul) {
      ul.addEventListener("mouseleave", closeItem);
    }
  });
}

function customMobileMenu() {
  const menuTrigger = document.querySelector(
    "header-drawer .menu-drawer-container"
  );
  const mobileMenu = document.querySelector(".custom-mobile-menu");
  const closeButton = document.querySelector(
    ".custom-mobile-menu__close-button"
  );
  const overlay = document.querySelector(".custom-mobile-menu__overlay");
  const announcementBar = document.querySelector(".announcement-bar-wrapper");
  const body = document.body;

  let scrollPosition = 0; // Store current scroll position

  if (menuTrigger && mobileMenu) {
    menuTrigger.addEventListener("click", function (event) {
      event.preventDefault(); // Prevent default summary toggle behavior
      scrollPosition = window.scrollY; // Save current scroll position
      body.style.position = "fixed"; // Prevent scrolling
      body.style.top = `-${scrollPosition}px`; // Keep position
      body.style.width = "100%"; // Ensure no layout shift
      body.style.overflow = "hidden"; // Hide scrollbars

      mobileMenu.classList.add("open");
      overlay.style.display = "block"; // Show overlay
      announcementBar.style.zIndex = "3"; // Lower z-index when menu is open
    });

    function closeMenu() {
      mobileMenu.classList.remove("open");
      overlay.style.display = "none"; // Hide overlay

      // Restore scrolling
      body.style.position = "";
      body.style.top = "";
      body.style.width = "";
      body.style.overflow = "";
      window.scrollTo(0, scrollPosition); // Restore scroll position

      // Wait for CSS transition to complete before resetting z-index
      mobileMenu.addEventListener("transitionend", function resetZIndex() {
        announcementBar.style.zIndex = "4"; // Reset z-index after transition
        mobileMenu.removeEventListener("transitionend", resetZIndex);
      });
    }

    closeButton.addEventListener("click", closeMenu);
    overlay.addEventListener("click", closeMenu);
  }
}

function addItemToCart(variant_id, product_title) {
  let cart =
    document.querySelector("cart-notification") ||
    document.querySelector("cart-drawer");
  let formData = {
    items: [
      {
        id: variant_id,
        quantity: 1,
      },
    ],
    sections: cart.getSectionsToRender().map((section) => section.id),
  };

  cart.setActiveElement(document.activeElement);
  const config = fetchConfig("json");
  config.headers["X-Requested-With"] = "XMLHttpRequest";
  config.body = JSON.stringify(formData);

  fetch(`${routes.cart_add_url}`, config)
    .then((response) => response.json())
    .then((response) => {
      if (response.errors) {
        let errorMessage =
          "You can't add more " + product_title + " to the cart.";
        alert(errorMessage);
        return;
      } else {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: "product-form",
          productVariantId: variant_id,
        });

        let cartObj = {};
        Object.assign(cartObj, response.items[0]);
        Object.assign(cartObj, { sections: response.sections });
        cart.renderContents(cartObj);
        cart.classList.remove("is-empty");
        trapFocus(
          document.getElementById("CartDrawer"),
          document.getElementById("CartDrawer")
        );
      }
    });
}

function customMultipleVideoModal() {
  var triggers = document.querySelectorAll(".multipleVideoTrigger");
  var closeBtn = document.querySelector(".close");
  var modal = document.getElementById("videoModal");
  var video = document.getElementById("modalVideo");

  // Guard: without the theme #videoModal markup, do not intercept clicks.
  // Trigger anchors then behave as normal links to the video URL.
  if (!triggers.length || !modal || !video) return;

  function openModal(videoUrl) {
    modal.style.display = "flex";
    video.src = videoUrl;
  }

  function closeModal() {
    modal.style.display = "none";
    video.removeAttribute("src");
  }

  triggers.forEach(function (trigger) {
    trigger.addEventListener("click", function (event) {
      event.preventDefault();
      openModal(this.href);
    });
  });

  if (closeBtn) {
    closeBtn.addEventListener("click", closeModal);
  }

  window.addEventListener("click", function (event) {
    if (event.target === modal) {
      closeModal();
    }
  });
}

function customProductVideoModal() {
  var trigger1 = document.getElementById("productVideoTrigger");
  var closeBtn = document.getElementsByClassName("close-product-video")[0];
  var modal = document.getElementById("videoProductModal");
  var video = document.getElementById("modalVideoProduct");

  function openModal(src) {
    modal.style.display = "flex";

    // Set video source
    video.src = src;
    video.muted = true;
    video.playsInline = true;

    // Try to play and fullscreen
    video
      .play()
      .then(() => {
        if (video.requestFullscreen) {
          video.requestFullscreen();
        } else if (video.webkitEnterFullscreen) {
          video.webkitEnterFullscreen(); // iOS Safari
        }
      })
      .catch((err) => {
        console.warn("Autoplay failed:", err);
      });
  }

  function closeModal() {
    modal.style.display = "none";
    video.pause();
    video.removeAttribute("src");
    video.load(); // reset
  }

  if (trigger1) {
    trigger1.addEventListener("click", function (event) {
      event.preventDefault();
      openModal(event.currentTarget.href);
    });
  }

  const observer = new MutationObserver(function () {
    const trigger2 = document.getElementById("preorderVideoTrigger");
    if (trigger2) {
      trigger2.addEventListener("click", function (event) {
        event.preventDefault();
        openModal(event.currentTarget.href);
      });
      observer.disconnect();
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });

  if (closeBtn) {
    closeBtn.addEventListener("click", function () {
      closeModal();
    });
  }

  window.addEventListener("click", function (event) {
    if (event.target === modal) {
      closeModal();
    }
  });
}

function customVideoGalleryModal() {
  var triggers = document.querySelectorAll(".videoGalleryTrigger");
  var closeBtn = document.getElementsByClassName("close")[0];
  var modal = document.getElementById("videoModal");
  var video = document.getElementById("modalVideo");

  // Function to open the modal and set video src
  function openModal(videoUrl) {
    modal.style.display = "flex";
    video.src = videoUrl;
  }

  // Function to close the modal and reset video
  function closeModal() {
    modal.style.display = "none";
    video.removeAttribute("src");
  }

  // Event listeners for each video trigger
  if (triggers) {
    triggers.forEach(function (trigger) {
      trigger.addEventListener("click", function (event) {
        event.preventDefault();
        var videoUrl = this.getAttribute("data-video-url");
        openModal(videoUrl);
      });
    });
  }

  // Event listener for closing the modal
  if (closeBtn) {
    closeBtn.addEventListener("click", function () {
      closeModal();
    });
  }

  // Event listener for clicking outside the modal to close it
  window.addEventListener("click", function (event) {
    if (event.target === modal) {
      closeModal();
    }
  });
}

function customVideoIframeModal() {
  const modal = document.getElementById("videoIframeModal");
  const closeBtn = document.getElementById("closeIframeModal");
  const videoFrame = document.getElementById("videoIframeModal_video");
  if (!modal) return;
  const wrapper = modal.querySelector(".video-iframe-modal_wrapper");

  if (wrapper) {
    wrapper.style.transform = "scale(0.7)";
    wrapper.style.opacity = "0";
    wrapper.style.transition = "transform 0.3s ease, opacity 0.3s ease";
  }

  const triggers = document.querySelectorAll(".video-iframe-modal-trigger");

  triggers.forEach(button => {
    button.addEventListener("click", function () {
      let videoLink;
      if (window.innerWidth <= 768) {
        // mobile
        videoLink = this.getAttribute("data-video-mobile") || this.getAttribute("data-video");
      } else {
        // desktop
        videoLink = this.getAttribute("data-video");
      }

      if (!videoLink) return;

      let videoID = "";
      if (videoLink.includes("watch?v=")) {
        try {
          videoID = new URL(videoLink).searchParams.get("v");
        } catch {
          videoID = videoLink.split("watch?v=")[1];
        }
      } else if (videoLink.includes("youtu.be/")) {
        videoID = videoLink.split("youtu.be/")[1].split("?")[0];
      } else if (videoLink.includes("youtube.com/shorts/")) {
        videoID = videoLink.split("shorts/")[1].split("?")[0];
      } else {
        videoID = videoLink;
      }

      const videoURL = "https://www.youtube.com/embed/" + videoID + "?autoplay=1&rel=0";
      videoFrame.src = videoURL;
      modal.style.display = "flex";

      // Set aspect ratio dynamically
      if (window.innerWidth <= 768 && this.getAttribute("data-video-mobile")) {
        wrapper.style.aspectRatio = "9 / 16"; // mobile with dedicated video
      } else {
        wrapper.style.aspectRatio = "16 / 9"; // default desktop or fallback
      }

      // Animate in
      requestAnimationFrame(() => {
        wrapper.style.transform = "scale(1)";
        wrapper.style.opacity = "1";
      });
    });
  });

  function closeModal() {
    if (!wrapper) return;
    wrapper.style.transform = "scale(0.7)";
    wrapper.style.opacity = "0";

    setTimeout(() => {
      modal.style.display = "none";
      videoFrame.src = "";
    }, 300);
  }

  closeBtn.addEventListener("click", closeModal);

  modal.addEventListener("click", function (e) {
    if (e.target === modal) {
      closeModal();
    }
  });
}

function customSelectWarranty(element, radioId) {
  // Uncheck all radio buttons first
  var radios = document.querySelectorAll(".warranty-radio");
  radios.forEach(function (radio) {
    radio.checked = false;
  });

  // Check the radio button associated with the clicked .warranty div
  document.getElementById(radioId).checked = true;

  // Remove 'selected' class from all .warranty divs
  var warrantyDivs = document.querySelectorAll(".warranty");
  warrantyDivs.forEach(function (div) {
    div.classList.remove("selected");
  });

  // Add 'selected' class to the clicked .warranty div
  element.classList.add("selected");
}

function customProductPopups() {
  let scrollLockCount = 0;

  function disableScroll() {
    scrollLockCount++;
    if (scrollLockCount === 1) {
      document.body.style.overflow = "hidden";
      document.documentElement.style.overflow = "hidden";
    }
  }

  function enableScroll() {
    scrollLockCount = Math.max(0, scrollLockCount - 1);
    if (scrollLockCount === 0) {
      document.body.style.overflow = "";
      document.documentElement.style.overflow = "";
    }
  }

  function closeAllPopups() {
    const popups = document.querySelectorAll(
      ".custom-popup-preorder.show, .custom-popup-add-to-cart.show"
    );
    popups.forEach((popup) => popup.classList.remove("show"));
    enableScroll();
  }

  function customPopupPreorder() {
    const container = document.querySelector(
      ".custom-popup-preorder .container"
    );
    const popup = document.getElementById("custom-popup-preorder");
    const containerCloseButton = document.getElementById(
      "preorder-container-close"
    );
    const popupTriggers = document.querySelectorAll(".popup-preorder-trigger");

    if (
      !container ||
      !popup ||
      !containerCloseButton ||
      popupTriggers.length === 0
    ) {
      return;
    }

    function openPopup() {
      popup.classList.add("show");
      disableScroll();
    }

    function closePopup() {
      popup.classList.remove("show");
      enableScroll();
    }

    popupTriggers.forEach((trigger) => {
      trigger.addEventListener("click", openPopup);
    });

    containerCloseButton.addEventListener("click", closePopup);

    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape") closePopup();
    });
  }

function customPopupAddToCart(triggerSelector, popupId) {
  const popup = document.getElementById(popupId);
  if (!popup) return;

  const container = popup.querySelector(".container");
  const infoButtons = popup.querySelectorAll(
    ".custom-popup-add-to-cart__content__info"
  );
  const infoContainer = document.querySelector(".info-container");
  const infoCloseButton = document.querySelector(".info-container-close");
  const containerCloseButton = container.querySelector(".container-close");
  const popupTriggers = document.querySelectorAll(triggerSelector);

  if (!container || !popupTriggers.length) return;

  let activeButton = null;

  function updateInfoContainerHeight() {
    if (window.innerWidth > 768 && container) {
      infoContainer.style.height = `${container.getBoundingClientRect().height}px`;
    }
  }

  function updateContainerMargin() {
    if (window.innerWidth > 768) {
      requestAnimationFrame(() => {
        setTimeout(() => {
          const infoContainerWidth = infoContainer.offsetWidth;
          container.style.marginRight = infoContainer.classList.contains("show")
            ? "0"
            : `-${infoContainerWidth}px`;
        }, 50);
      });
    }
  }

  function openInfoContainer(button) {
    if (!infoContainer) return;

    updateInfoContainerHeight();
    infoContainer.style.visibility = "hidden";
    infoContainer.classList.add("show");
    const newWidth = infoContainer.offsetWidth;
    infoContainer.classList.remove("show");
    infoContainer.style.visibility = "visible";
    infoContainer.style.width = `${newWidth}px`;

    requestAnimationFrame(() => {
      infoContainer.classList.add("show");
      container.classList.add("info-open");
    });

    const titleEl = document.querySelector(".info-container-title");
    const descEl = document.querySelector(".info-container-description");
    const imageEl = document.querySelector(".info-container-image");

    if (titleEl) titleEl.innerHTML = button.getAttribute("data-info-title");
    if (descEl) descEl.innerHTML = button.getAttribute("data-info-description");

    const imageSource = button.getAttribute("data-info-image");
    if (imageEl) {
      if (imageSource) {
        imageEl.src = imageSource;
        imageEl.style.display = "block";
      } else {
        imageEl.style.display = "none";
      }
    }

    activeButton = button;
    updateContainerMargin();
  }

  function closeInfoContainer() {
    if (!infoContainer) return;

    infoContainer.classList.remove("show");
    container.classList.remove("info-open");
    activeButton = null;
    updateContainerMargin();
  }

  function openPopup() {
    updateContainerMargin();
    popup.classList.add("show");
    disableScroll();
  }

  function closePopup() {
    popup.classList.remove("show");
    closeInfoContainer();
    enableScroll();
  }

  popupTriggers.forEach((trigger) => {
    trigger.addEventListener("click", (event) => {
      event.preventDefault();
      openPopup();
    });
  });

  if (infoButtons) {
    infoButtons.forEach((button) => {
      button.addEventListener("click", () => {
        if (activeButton === button && infoContainer.classList.contains("show")) {
          closeInfoContainer();
          return;
        }
        if (infoContainer.classList.contains("show")) {
          closeInfoContainer();
          setTimeout(() => openInfoContainer(button), 400);
        } else {
          openInfoContainer(button);
        }
      });
    });
  }

  if (infoCloseButton) infoCloseButton.addEventListener("click", closeInfoContainer);
  if (containerCloseButton) containerCloseButton.addEventListener("click", closePopup);

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape") closePopup();
  });

  window.addEventListener("resize", () => {
    updateInfoContainerHeight();
    updateContainerMargin();
  });

  updateContainerMargin();
}

// -------------------------------------------------------------------------
// Promo popup (Fusion Grit welkomstkorting)
// Triggered by buy_button_popup_function = 'promo' → class: popup-promo-trigger
// Does NOT open the addon popup — hands the variant directly to FusionGritPopup.
// -------------------------------------------------------------------------
function customPopupPromo() {
  document.addEventListener('click', function(event) {
    const button = event.target.closest('.popup-promo-trigger');
    if (!button) return;

    event.preventDefault();

    if (!window.FusionGritPopup) {
      console.warn('[Promo] FusionGritPopup not found.');
      return;
    }

    // Resolve variant ID
    let variantId;
    const variantSelect = document.querySelector('variant-selects');

    if (variantSelect) {
      const variants = JSON.parse(variantSelect.querySelector('script[type="application/json"]')?.textContent || '[]');
      const selectedOptions = Array.from(variantSelect.querySelectorAll('input[type="radio"]:checked')).map(i => i.value);
      const matched = variants.find(v => v.options.every((opt, i) => opt === selectedOptions[i]));
      if (!matched) { console.error('[Promo] No matching variant'); return; }
      variantId = matched.id;
    } else {
      variantId = document.querySelector('.default-variant-id')?.value;
    }

    if (!variantId) return;

    // Build Poopy items array (same as quickAddToCart would)
    const sellingPlan = document.querySelector('input[name="selling_plan"]')?.value;
    const quantity = parseInt(document.querySelector('#quantity-input')?.value) || 1;
    const poopyItems = [{ id: parseInt(variantId, 10), quantity, selling_plan: sellingPlan }];

    // Include addons if any
    if (Array.isArray(window.selectedProductAddons)) {
      window.selectedProductAddons.forEach(addon => {
        const exists = poopyItems.some(p => p.id === addon.id);
        if (!exists) poopyItems.push(addon);
      });
    }

    const popupOpened = window.FusionGritPopup.openWithItems(poopyItems, button);

    if (!popupOpened) {
      // Popup couldn't open (e.g. no FG variant configured) — add to cart normally
      const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      const spinner = button.querySelector('.loading__spinner');
      const buttonText = button.querySelector('.buy-button__ripple__text');

      if (spinner) spinner.style.opacity = '1';
      if (buttonText) buttonText.style.opacity = '0';

      const sellingPlan = document.querySelector('input[name="selling_plan"]')?.value;
      const quantity = parseInt(document.querySelector('#quantity-input')?.value) || 1;

      const formData = {
        items: poopyItems.map(p => ({
          id: p.id,
          quantity: p.quantity || 1,
          properties: p.properties,
          selling_plan: p.selling_plan
        })),
        sections: cart?.getSectionsToRender?.().map(s => s.id) || [],
      };

      const config = fetchConfig('json');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      config.body = JSON.stringify(formData);

      fetch(routes.cart_add_url, config)
        .then(r => r.json())
        .then(response => {
          if (response.errors) {
            alert('Er is een probleem bij het toevoegen van items aan de winkelwagen.');
          } else {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: poopyItems[0].id });
            if (cart) {
              const cartObj = { ...response.items[0], sections: response.sections };
              cart.renderContents(cartObj);
              cart.classList.remove('is-empty');
            }
          }
        })
        .finally(() => {
          if (spinner) spinner.style.opacity = '0';
          if (buttonText) buttonText.style.opacity = '1';
        });
    }
  });
}

// ─────────────────────────────────────────────────────────────────────────────
// Subscription popup (Vakantiegeld – Mineral Essentials)
// Triggered by .popup-subscription-trigger (buy_buttons_subscription block).
//
// Cart-state rules checked before opening popup:
//   Rule 2 – VKG Essentials already in cart → skip popup, add hardware only
//   Rule 3 – Manual Essentials in cart      → skip popup, add hardware only
// Rule 1 (remove Essentials if hardware removed) is in vakantiegeld-popup.js.
// ─────────────────────────────────────────────────────────────────────────────
function customPopupSubscription() {
  document.addEventListener('click', function(event) {
    const button = event.target.closest('.popup-subscription-trigger');
    if (!button) return;
    event.preventDefault();

    if (!window.VakantiegeldPopup) {
      console.warn('[Subscription] VakantiegeldPopup not found — is vakantiegeld-popup.js loaded?');
      return;
    }

    // ── Resolve hardware variant ID ──────────────────────────────────────────
    let variantId;
    const variantSelect = document.querySelector('variant-selects');
    if (variantSelect) {
      const variants = JSON.parse(
        variantSelect.querySelector('script[type="application/json"]')?.textContent || '[]'
      );
      const selected = Array.from(
        variantSelect.querySelectorAll('input[type="radio"]:checked')
      ).map(i => i.value);
      const matched = variants.find(v => v.options.every((o, i) => o === selected[i]));
      if (!matched) { console.error('[Subscription] No matching variant.'); return; }
      variantId = matched.id;
    } else {
      variantId = document.querySelector('.default-variant-id')?.value;
    }
    if (!variantId) return;

    const sellingPlan = document.querySelector('input[name="selling_plan"]')?.value;
    const quantity    = parseInt(document.querySelector('#quantity-input')?.value) || 1;
    const items       = [{ id: parseInt(variantId, 10), quantity, selling_plan: sellingPlan }];

    if (Array.isArray(window.selectedProductAddons)) {
      window.selectedProductAddons.forEach(addon => {
        if (!items.some(p => p.id === addon.id)) items.push(addon);
      });
    }

    // ── Brief loading state while cart is checked ────────────────────────────
    const spinner    = button.querySelector('.loading__spinner');
    const buttonText = button.querySelector('.buy-button__ripple__text');
    const showLoad   = () => { if (spinner) spinner.style.opacity='1'; if (buttonText) buttonText.style.opacity='0'; };
    const hideLoad   = () => { if (spinner) spinner.style.opacity='0'; if (buttonText) buttonText.style.opacity='1'; };
    showLoad();

    // ── Cart-state checks (rules 2 & 3) ─────────────────────────────────────
    fetch('/cart.js', { headers: { 'Content-Type': 'application/json' } })
      .then(r => r.json())
      .then(cart => {
        const essId = String(window.VKG_CONFIG?.mineralEssentialsVariantId || '');

        // Rule 2: VKG Essentials already auto-added
        const hasVkg = cart.items.some(item =>
          item.properties && item.properties['_vkg_source'] === 'vakantiegeld'
        );

        // Rule 3: Customer manually added Essentials
        const hasManual = essId && cart.items.some(item =>
          String(item.variant_id) === essId &&
          !(item.properties && item.properties['_vkg_source'] === 'vakantiegeld')
        );

        hideLoad();

        if (hasVkg || hasManual) {
          addHardwareDirectly(items, button);
          return;
        }

        const opened = window.VakantiegeldPopup.openWithItems(items, button);
        if (!opened) addHardwareDirectly(items, button);
      })
      .catch(() => {
        hideLoad();
        const opened = window.VakantiegeldPopup.openWithItems(items, button);
        if (!opened) addHardwareDirectly(items, button);
      });
  });

  function addHardwareDirectly(items, button) {
    const cart       = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    const spinner    = button.querySelector('.loading__spinner');
    const buttonText = button.querySelector('.buy-button__ripple__text');
    if (spinner)    spinner.style.opacity    = '1';
    if (buttonText) buttonText.style.opacity = '0';

    const formData = {
      items: items.map(p => ({ id: p.id, quantity: p.quantity||1, properties: p.properties, selling_plan: p.selling_plan })),
      sections: cart?.getSectionsToRender?.().map(s => s.id) || []
    };
    const config = fetchConfig('json');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    config.body = JSON.stringify(formData);

    fetch(routes.cart_add_url, config)
      .then(r => r.json())
      .then(res => {
        if (res.errors) { alert('Er is een probleem bij het toevoegen van items aan de winkelwagen.'); return; }
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: items[0].id });
        if (cart) {
          cart.renderContents({ ...res.items[0], sections: res.sections });
          cart.classList.remove('is-empty');
        }
      })
      .catch(() => alert('Er is een probleem bij het toevoegen van items aan de winkelwagen.'))
      .finally(() => {
        if (spinner)    spinner.style.opacity    = '0';
        if (buttonText) buttonText.style.opacity = '1';
      });
  }
}

// Initialize both popups
customPopupAddToCart(".popup-add-to-cart-trigger", "custom-popup-add-to-cart");
customPopupAddToCart(
  ".popup-additional-add-to-cart-trigger",
  "custom-popup-additional-add-to-cart"
);

  customPopupPreorder();
  customPopupPromo();
  customPopupSubscription();
  const cartDrawer = document.querySelector("cart-drawer");
  if (cartDrawer) {
    const observer = new MutationObserver(() => {
      if (cartDrawer.classList.contains("active")) {
        closeAllPopups();
      } else {
        enableScroll();
      }
    });

    observer.observe(cartDrawer, {
      attributes: true,
      attributeFilter: ["class"],
      attributeOldValue: true,
    });
  }
}

function customPopupWarranty() {
  // Select the hidden input field for warranty in the popup
  let optionInput = document.getElementById(
    "custom_popup_warranty_option_input"
  );

  // Select all warranty radio buttons
  const warrantyOptions = document.querySelectorAll(
    ".custom-popup-add-to-cart__content__warranty__form input[type='radio']"
  );

  // Loop through each radio button and add a change event listener
  warrantyOptions.forEach((option) => {
    option.addEventListener("change", function () {
      // Get the data-popup-warranty attribute value
      const selectedWarranty = this.getAttribute("data-popup-warranty");

      // If the hidden input exists, update its value or remove it based on the condition
      if (optionInput) {
        if (selectedWarranty) {
          optionInput.value = selectedWarranty; // Update the input value
        } else {
          optionInput.remove(); // Remove the input if no warranty is selected
          optionInput = null; // Reset reference to null
        }
      } else if (selectedWarranty) {
        // Create and append the hidden input if it doesn't exist
        optionInput = document.createElement("input");
        optionInput.type = "hidden";
        optionInput.name = "id[]"; // Match the name to your existing hidden inputs
        optionInput.id = "custom_popup_warranty_option_input"; // Maintain the same ID
        optionInput.value = selectedWarranty; // Set the value

        // Append the input to the form with class 'popup-add-to-cart-form'
        document
          .querySelector(".popup-add-to-cart-form")
          .appendChild(optionInput);
      }
    });
  });
}

function customPopupInsurance() {
  // Select the hidden input field for insurance in the popup
  let optionInput = document.getElementById(
    "custom_popup_insurance_option_input"
  );

  // Select all insurance radio buttons
  const insuranceOptions = document.querySelectorAll(
    ".custom-popup-add-to-cart__content__insurance__form input[type='radio']"
  );

  // Loop through each radio button and add a change event listener
  insuranceOptions.forEach((option) => {
    option.addEventListener("change", function () {
      // Get the data-popup-insurance attribute value
      const selectedInsurance = this.getAttribute("data-popup-insurance");

      // If the hidden input exists, update its value or remove it based on the condition
      if (optionInput) {
        if (selectedInsurance) {
          optionInput.value = selectedInsurance; // Update the input value
        } else {
          optionInput.remove(); // Remove the input if no insurance is selected
          optionInput = null; // Reset reference to null
        }
      } else if (selectedInsurance) {
        // Create and append the hidden input if it doesn't exist
        optionInput = document.createElement("input");
        optionInput.type = "hidden";
        optionInput.name = "id[]"; // Match the name to your existing hidden inputs
        optionInput.id = "custom_popup_insurance_option_input"; // Maintain the same ID
        optionInput.value = selectedInsurance; // Set the value

        // Append the input to the form with class 'popup-add-to-cart-form'
        document
          .querySelector(".popup-add-to-cart-form")
          .appendChild(optionInput);
      }
    });
  });
}

function customPopupAddon() {
  // Select the hidden input field for addon in the popup
  let optionInput = document.getElementById("custom_popup_addon_option_input");

  // Select all addon radio buttons
  const addonOptions = document.querySelectorAll(
    ".custom-popup-add-to-cart__content__addon__form input[type='radio']"
  );

  // Loop through each radio button and add a change event listener
  addonOptions.forEach((option) => {
    option.addEventListener("change", function () {
      // Get the data-popup-addon attribute value
      const selectedAddon = this.getAttribute("data-popup-addon");

      // If the hidden input exists, update its value or remove it based on the condition
      if (optionInput) {
        if (selectedAddon) {
          optionInput.value = selectedAddon; // Update the input value
        } else {
          optionInput.remove(); // Remove the input if no addon is selected
          optionInput = null; // Reset reference to null
        }
      } else if (selectedAddon) {
        // Create and append the hidden input if it doesn't exist
        optionInput = document.createElement("input");
        optionInput.type = "hidden";
        optionInput.name = "id[]"; // Match the name to your existing hidden inputs
        optionInput.id = "custom_popup_addon_option_input"; // Maintain the same ID
        optionInput.value = selectedAddon; // Set the value

        // Append the input to the form with class 'popup-add-to-cart-form'
        document
          .querySelector(".popup-add-to-cart-form")
          .appendChild(optionInput);
      }
    });
  });
}

function customAddOns() {
  const addOnContainers = document.querySelectorAll(".custom-add-ons");

  addOnContainers.forEach((container) => {
    const addOnOptions = container.querySelectorAll(".custom-add-ons__product");

    addOnOptions.forEach((option) => {
      option.addEventListener("click", function () {
        const isSelected = this.classList.contains("selected");
        const addOnId = this.getAttribute("data-add-on-option");
        const form = document.querySelector(".poopy-product-page-form");

        if (isSelected) {
          // Unselect it
          this.classList.remove("selected");

          // Remove the corresponding hidden input
          const existingInput = document.querySelector(
            `input[data-addon-id="${addOnId}"]`
          );
          if (existingInput) existingInput.remove();
        } else {
          // Select it
          this.classList.add("selected");

          // Create a new hidden input for this selection
          const addOnInput = document.createElement("input");
          addOnInput.type = "hidden";
          addOnInput.name = "id[]";
          addOnInput.value = addOnId;
          addOnInput.setAttribute("data-addon-id", addOnId); // Unique identifier for removal

          form.appendChild(addOnInput);
        }
      });
    });
  });
}

function customBuyButtonsFlow() {
  const atcTrigger = document.querySelector('.buy-buttons-flow-trigger');
  const atcModal = document.getElementById('atcModal');

  if (!atcTrigger || !atcModal) return; // exit if elements not found

  const atcClose = atcModal.querySelector('.atc-modal_close');
  const wrapper = atcModal.querySelector('.atc-modal_container'); 

  if (!wrapper || !atcClose) return;

  const isMobile = window.innerWidth <= 768;

  // Initial hidden state
  atcModal.style.display = 'none';
  wrapper.style.transition = 'transform 0.3s ease, opacity 0.3s ease';
  
  if (isMobile) {
    wrapper.style.transform = 'translateY(100%)';
  } else {
    wrapper.style.transform = 'scale(0.7)';
    wrapper.style.opacity = '0';
  }

  // Open modal with animation and disable scroll
  atcTrigger.addEventListener('click', () => {
    atcModal.style.display = 'flex';

    // Disable scroll
    document.body.style.overflow = 'hidden';
    document.documentElement.style.overflow = 'hidden';

    requestAnimationFrame(() => {
      if (isMobile) {
        wrapper.style.transform = 'translateY(0%)';
      } else {
        wrapper.style.transform = 'scale(1)';
        wrapper.style.opacity = '1';
      }
    });
  });

  // Close modal with animation and enable scroll
  atcClose.addEventListener('click', () => {
    if (isMobile) {
      wrapper.style.transform = 'translateY(100%)';
    } else {
      wrapper.style.transform = 'scale(0.7)';
      wrapper.style.opacity = '0';
    }

    setTimeout(() => {
      atcModal.style.display = 'none';

      // Re-enable scroll
      document.body.style.overflow = '';
      document.documentElement.style.overflow = '';
    }, 300); // match transition duration
  });
}

function customBuyButtonsFlow2() {
  const atcTriggers = document.querySelectorAll('.atc-modal-2-trigger');
  const atcModal2 = document.getElementById('atcModal2');
  if (!atcModal2 || atcTriggers.length === 0) return; // exit if modal2 or triggers not found

  const atcClose2 = atcModal2.querySelector('.atc-modal-2_close');
  const wrapper2 = atcModal2.querySelector('.atc-modal-2_container');
  if (!wrapper2 || !atcClose2) return; // exit if container or close button not found

  const atcModal1 = document.getElementById('atcModal');
  const wrapper1 = atcModal1?.querySelector('.atc-modal_container'); // optional chaining
  if (!wrapper1) return;

  const isMobile = window.innerWidth <= 768;

  // Ensure wrapper2 is hidden initially
  wrapper2.style.transition = 'transform 0.3s ease, opacity 0.3s ease';
  if (isMobile) {
    wrapper2.style.transform = 'translateY(100%)';
  } else {
    wrapper2.style.transform = 'scale(0.7)';
    wrapper2.style.opacity = '0';
  }

  // Open modal2
  atcTriggers.forEach(trigger => {
    trigger.addEventListener('click', () => {
      if (isMobile) {
        wrapper1.style.transform = 'translateY(100%)';
      } else {
        wrapper1.style.transform = 'scale(0.7)';
        wrapper1.style.opacity = '0';
      }

      atcModal2.style.display = 'flex';
      requestAnimationFrame(() => {
        if (isMobile) {
          wrapper2.style.transform = 'translateY(0%)';
        } else {
          wrapper2.style.transform = 'scale(1)';
          wrapper2.style.opacity = '1';
        }
      });
    });
  });

  // Close modal2
  atcClose2.addEventListener('click', () => {
    if (isMobile) {
      wrapper2.style.transform = 'translateY(100%)';
    } else {
      wrapper2.style.transform = 'scale(0.7)';
      wrapper2.style.opacity = '0';
    }

    setTimeout(() => {
      atcModal2.style.display = 'none';
      if (isMobile) {
        wrapper1.style.transform = 'translateY(0%)';
      } else {
        wrapper1.style.transform = 'scale(1)';
        wrapper1.style.opacity = '1';
      }
    }, 300);
  });
}

function atcModalAccordion() {
  const headers = document.querySelectorAll('.atc-modal_accordion-header');

  headers.forEach((header) => {
    header.addEventListener('click', () => {
      const content = header.nextElementSibling;
      const icon = header.querySelector('.icon span');

      if (content.style.display === 'block') {
        content.style.display = 'none';
        icon.textContent = '+';
      } else {
        content.style.display = 'block';
        icon.textContent = '-';
      }
    });
  });
}

function customFreeItems() {
  // Select all free items
  const freeItems = document.querySelectorAll(
    ".custom-free-items__container-item"
  );

  // Loop through each item and check if it has a data-free-item attribute
  freeItems.forEach((item) => {
    const freeItemValue = item.getAttribute("data-free-item");

    if (freeItemValue) {
      // Create a hidden input for each free item
      const freeItemInput = document.createElement("input");
      freeItemInput.type = "hidden";
      freeItemInput.name = "id[]"; // Match the name to your existing hidden inputs
      freeItemInput.value = freeItemValue; // Set the value to the data-free-item attribute

      // Append the input to the form
      document
        .querySelector(".poopy-product-page-form")
        .appendChild(freeItemInput);
    }
  });
}

function customOpenProductDetail(evt, sectionId) {
  var i, tablinks, quickTablinks;
  var section = document.getElementById(sectionId);

  // Remove the active class from all tablinks or quick-tablinks
  tablinks = document.getElementsByClassName("tablinks");
  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].classList.remove("active");
  }
  quickTablinks = document.getElementsByClassName("quick-tablinks");
  for (i = 0; i < quickTablinks.length; i++) {
    quickTablinks[i].classList.remove("active");
  }

  // Add active class to the clicked tablinks or quick-tablinks
  evt.currentTarget.classList.add("active");

  // Find and add active class to corresponding quick-tablink
  quickTablinks = document.getElementsByClassName("quick-tablinks");
  for (i = 0; i < quickTablinks.length; i++) {
    if (
      quickTablinks[i].innerText.trim() === evt.currentTarget.innerText.trim()
    ) {
      quickTablinks[i].classList.add("active");
      break; // Stop loop once found and added class
    }
  }

  // Scroll to the section
  if (section) {
    var navHeight = 55; // Adjust this value to match the height of the product-details-navigation
    var sectionOffset = section.getBoundingClientRect().top;
    var targetScrollPosition = window.scrollY + sectionOffset - navHeight;

    window.scrollTo({
      top: targetScrollPosition,
      behavior: "smooth",
    });
  }
}

function customProductDetailNavigation() {
  var navShown = false;
  var navigation = document.querySelector(".product-details-navigation");
  var tabs = document.querySelector(".product-details-tabs");
  // var tabsPosition = tabs.offsetTop + tabs.offsetHeight;

  if (tabs) {
    var tabsPosition = tabs.offsetTop + 155;
  }

  function checkScroll() {
    if (window.pageYOffset >= tabsPosition && !navShown) {
      navigation.classList.add("show");
      navShown = true;
    } else if (window.pageYOffset < tabsPosition && navShown) {
      navigation.classList.remove("show");
      navShown = false;
    }
  }

  window.addEventListener("scroll", checkScroll);

  // Initial check when page loads
  checkScroll();
}

function customDetectProductDetailSection() {
  function handleIntersection(entries, observer) {
    entries.forEach((entry) => {
      var sectionId = entry.target.id;
      var quickTablink = document.querySelector(
        `.quick-tablinks[data-section="${sectionId}"]`
      );

      if (entry.isIntersecting) {
        // Add 'active' class to the corresponding quick-tablink
        if (quickTablink) {
          quickTablink.classList.add("active");
        }
      } else {
        // Remove 'active' class from the corresponding quick-tablink
        if (quickTablink) {
          quickTablink.classList.remove("active");
        }
      }
    });
  }

  var options = {
    root: null,
    rootMargin: "0px",
    threshold: 0.5, // Trigger when 50% of the element is visible
  };

  var observer = new IntersectionObserver(handleIntersection, options);

  ["product-details-tabs", "specs", "faqs", "reviews"].forEach((sectionId) => {
    var section = document.getElementById(sectionId);
    if (section) {
      observer.observe(section);
    }
  });

  // Add event listeners to navigation buttons
  var allQuickTablinks = document.querySelectorAll(".quick-tablinks");
  allQuickTablinks.forEach((tablink) => {
    tablink.addEventListener("click", function (event) {
      event.preventDefault(); // Prevent default anchor behavior

      var sectionId = this.getAttribute("data-section");
      var section = document.getElementById(sectionId);
      if (section) {
        // Scroll to the section
        section.scrollIntoView({ behavior: "smooth" });

        // Update active state of navigation buttons
        allQuickTablinks.forEach((tab) => {
          tab.classList.remove("active");
        });
        this.classList.add("active");
      }
    });
  });
}

function customThumbnailSlider() {
  let slideIndex = 0;
  showSlides(slideIndex);

  function changeSlide(n) {
    showSlides((slideIndex += n));
  }

  function currentSlide(n) {
    showSlides((slideIndex = n - 1));
  }

  function showSlides(n) {
    const slides = document.getElementsByClassName("slide");
    const dots = document.getElementsByClassName("dot");

    // Check if slides and dots exist
    if (slides.length === 0 || dots.length === 0) {
      return; // Exit function to prevent further execution
    }

    if (n >= slides.length) {
      slideIndex = 0;
    }
    if (n < 0) {
      slideIndex = slides.length - 1;
    }

    for (let i = 0; i < slides.length; i++) {
      slides[i].style.display = "none";
    }
    for (let i = 0; i < dots.length; i++) {
      dots[i].className = dots[i].className.replace(" active", "");
    }

    slides[slideIndex].style.display = "flex";
    dots[slideIndex].className += " active";
  }

  // Expose functions to the global scope
  window.changeSlide = changeSlide;
  window.currentSlide = currentSlide;
}

function videoStoriesSlider() {
  const leftArrow = document.querySelector(".left-arrow");
  const rightArrow = document.querySelector(".right-arrow");
  const container = document.querySelector(".video-stories-items");
  const item = document.querySelector(".video-stories-item");

  // Check if all required elements are present
  if (!leftArrow) {
    return;
  }
  if (!rightArrow) {
    return;
  }
  if (!container) {
    return;
  }
  if (!item) {
    return;
  }

  function updateArrows() {
    const maxScrollLeft = container.scrollWidth - container.clientWidth;

    if (container.scrollLeft <= 0) {
      leftArrow.style.display = "none";
    } else {
      leftArrow.style.display = "block";
    }

    if (container.scrollLeft >= maxScrollLeft - 1) {
      rightArrow.style.display = "none";
    } else {
      rightArrow.style.display = "block";
    }
  }

  leftArrow.addEventListener("click", () => {
    const itemWidth =
      item.clientWidth + parseInt(window.getComputedStyle(item).marginRight); // Get item width including margin
    container.scrollBy({
      top: 0,
      left: -itemWidth,
      behavior: "smooth",
    });
    setTimeout(updateArrows, 300); // Update arrows after scrolling
  });

  rightArrow.addEventListener("click", () => {
    const itemWidth =
      item.clientWidth + parseInt(window.getComputedStyle(item).marginRight); // Get item width including margin
    container.scrollBy({
      top: 0,
      left: itemWidth,
      behavior: "smooth",
    });
    setTimeout(updateArrows, 300); // Update arrows after scrolling
  });

  // Update arrows initially and on scroll
  container.addEventListener("scroll", updateArrows);
  updateArrows();
}

function customVideoStoriesModal() {
  var triggers = document.querySelectorAll(".videoStoriesTrigger");
  var closeBtn = document.getElementsByClassName("close-stories")[0];
  var modal = document.getElementById("videoStoriesModal");
  var video = document.getElementById("modalVideoStories");

  // Function to open the modal and set video src
  function openModal(videoUrl) {
    modal.style.display = "flex";
    video.src = videoUrl;
  }

  // Function to close the modal and reset video
  function closeModal() {
    modal.style.display = "none";
    video.removeAttribute("src");
  }

  // Event listeners for each video trigger
  if (triggers) {
    triggers.forEach(function (trigger) {
      trigger.addEventListener("click", function (event) {
        event.preventDefault();
        var videoUrl = this.getAttribute("data-video-url");
        openModal(videoUrl);
      });
    });
  }

  // Event listener for closing the modal
  if (closeBtn) {
    closeBtn.addEventListener("click", function () {
      closeModal();
    });
  }

  // Event listener for clicking outside the modal to close it
  window.addEventListener("click", function (event) {
    if (event.target === modal) {
      closeModal();
    }
  });
}

function customPlayVideoBlock() {
  const playBtn = document.getElementById("play-video");
  const video = document.getElementById("video");
  if (!playBtn || !video) return;
  playBtn.addEventListener("click", function (ev) {
    video.src += "&autoplay=1";
    ev.preventDefault();
  });
}

function customTimer() {
  const timerElement = document.querySelector(".custom-timer");
  if (!timerElement) {
    // console.log("Custom timer element does not exist.");
    return; // Exit the function if the timer element is not found
  }

  const countdownInput = document.getElementById("countdownDateTime");
  if (!countdownInput || !countdownInput.value) return; // No countdown configured on this page
  const dateTimeString = countdownInput.value;
  const [datePart, timePart] = dateTimeString.split(" ");
  const [month, day, year] = datePart.split("-").map(Number);
  const [hours, minutes, seconds] = timePart.split(":").map(Number);
  const countdownDate = new Date(
    year,
    month - 1,
    day,
    hours,
    minutes,
    seconds
  ).getTime(); // JS months are 0-indexed

  const updateCountdown = () => {
    const now = new Date().getTime();
    const distance = countdownDate - now;

    const days = Math.floor(distance / (1000 * 60 * 60 * 24));
    const hours = Math.floor(
      (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
    );
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((distance % (1000 * 60)) / 1000);

    const daysElement = document.querySelector(
      "#days .countdown-item-time span"
    );
    const hoursElement = document.querySelector(
      "#hours .countdown-item-time span"
    );
    const minutesElement = document.querySelector(
      "#minutes .countdown-item-time span"
    );
    const secondsElement = document.querySelector(
      "#seconds .countdown-item-time span"
    );

    if (distance < 0) {
      clearInterval(interval);
      if (daysElement) daysElement.textContent = "00";
      if (hoursElement) hoursElement.textContent = "00";
      if (minutesElement) minutesElement.textContent = "00";
      if (secondsElement) secondsElement.textContent = "00";
    } else {
      if (daysElement) daysElement.textContent = String(days).padStart(2, "0");
      if (hoursElement)
        hoursElement.textContent = String(hours).padStart(2, "0");
      if (minutesElement)
        minutesElement.textContent = String(minutes).padStart(2, "0");
      if (secondsElement)
        secondsElement.textContent = String(seconds).padStart(2, "0");
    }
  };

  const interval = setInterval(updateCountdown, 1000);
  updateCountdown();
}

function customTimerBlackTop() {
  const timerElement = document.querySelector(".custom-timer-black-top");
  if (!timerElement) {
    // console.log("Custom timer element does not exist.");
    return; // Exit the function if the timer element is not found
  }

  const countdownInput = document.getElementById("countdownDateTimeBottom");
  if (!countdownInput || !countdownInput.value) return; // No countdown configured on this page
  const dateTimeString = countdownInput.value;
  const [datePart, timePart] = dateTimeString.split(" ");
  const [month, day, year] = datePart.split("-").map(Number);
  const [hours, minutes, seconds] = timePart.split(":").map(Number);
  const countdownDate = new Date(
    year,
    month - 1,
    day,
    hours,
    minutes,
    seconds
  ).getTime(); // JS months are 0-indexed

  const updateCountdown = () => {
    const now = new Date().getTime();
    const distance = countdownDate - now;

    const days = Math.floor(distance / (1000 * 60 * 60 * 24));
    const hours = Math.floor(
      (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
    );
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((distance % (1000 * 60)) / 1000);

    const daysElement = document.querySelector(
      "#daysBottom .countdown-item-time span"
    );
    const hoursElement = document.querySelector(
      "#hoursBottom .countdown-item-time span"
    );
    const minutesElement = document.querySelector(
      "#minutesBottom .countdown-item-time span"
    );
    const secondsElement = document.querySelector(
      "#secondsBottom .countdown-item-time span"
    );

    if (distance < 0) {
      clearInterval(interval);
      if (daysElement) daysElement.textContent = "00";
      if (hoursElement) hoursElement.textContent = "00";
      if (minutesElement) minutesElement.textContent = "00";
      if (secondsElement) secondsElement.textContent = "00";
    } else {
      if (daysElement) daysElement.textContent = String(days).padStart(2, "0");
      if (hoursElement)
        hoursElement.textContent = String(hours).padStart(2, "0");
      if (minutesElement)
        minutesElement.textContent = String(minutes).padStart(2, "0");
      if (secondsElement)
        secondsElement.textContent = String(seconds).padStart(2, "0");
    }
  };

  const interval = setInterval(updateCountdown, 1000);
  updateCountdown();
}

function customOpenCartDrawer() {
  document.querySelectorAll('.cart-item').forEach(item => {
    const dl = item.querySelector('dl');
    const dt = dl?.querySelector('dt');

    if (dt && dt.textContent.includes('Gift ID')) {
      dl.style.display = 'none';
    }
  });

  window.addEventListener("load", function () {
    // Check if local storage has the value
    const storedValue = localStorage.getItem("Product Page");

    if (storedValue) {
      // If the value exists, click the cart icon
      const cartIcon = document.querySelector(".header__icon--cart");
      if (cartIcon) {
        cartIcon.click();

        // Remove the value from local storage after clicking the cart icon
        localStorage.removeItem("Product Page");
      }
    }

    // Add value to local storage when the form is submitted
    const form = document.getElementById("product-form");
    if (form) {
      form.addEventListener("submit", function () {
        const valueToStore = "Poopy Added";
        localStorage.setItem("Product Page", valueToStore);
      });
    }

    // Add value to local storage when the form is submitted
    const stickyform = document.getElementById("sticky-product-form");
    if (stickyform) {
      stickyform.addEventListener("submit", function () {
        const valueToStore = "Poopy Added";
        localStorage.setItem("Product Page", valueToStore);
      });
    }
  });
}

function customProductLightbox() {
  const images = document.querySelectorAll(
    ".custom-media-gallery__v2__image, .custom-product-images-mobile-slider .galmain .cpim-slide"
  );
  const lightbox = document.querySelector(".custom-product-lightbox");
  const closeButton = document.querySelector(
    ".custom-product-lightbox .icon-close-small"
  );

  if (!images.length || !lightbox || !closeButton) {
    return;
  }

  lightbox.style.opacity = 0;
  lightbox.style.transition = "opacity 0.3s ease-in-out";
  lightbox.style.display = "none";

  function disableScroll() {
    document.body.style.overflow = "hidden";
  }

  function enableScroll() {
    document.body.style.overflow = "";
  }

  function getSwiperInstance(container) {
    return container?.swiper || container;
  }

  function initializeSwipers(startIndex) {
    const mainSwiperContainer = document.querySelector(
      ".product-lightbox__swiper"
    );
    const thumbSwiperContainer = document.querySelector(
      ".product-lightbox__swiper-thumbnail"
    );

    if (!mainSwiperContainer || !thumbSwiperContainer) {
      // console.error("Swiper containers not found");
      return;
    }

    const mainSwiper = getSwiperInstance(mainSwiperContainer);
    const thumbSwiper = getSwiperInstance(thumbSwiperContainer);

    if (!mainSwiper || !thumbSwiper) {
      // console.error("Swiper instances not found");
      return;
    }

    mainSwiper.slideToLoop(startIndex);
    thumbSwiper.slideToLoop(startIndex);
  }

  images.forEach((image, index) => {
    image.style.cursor =
      "url('https://cdn.shopify.com/s/files/1/0872/1068/8837/files/zoom.svg?v=1741215365') 24 24, pointer";

    image.addEventListener("click", function (event) {
      if (
        event.target.closest(".info-modal-trigger") ||
        event.target.closest(".custom-product-video-button") ||
        event.target.closest(".ov-video-btn")
      ) {
        return;
      }

      lightbox.style.display = "block";
      setTimeout(() => {
        lightbox.style.opacity = 1;
      }, 10);
      disableScroll();

      let correctIndex = index;

      // If the clicked image is inside the mobile slider, get the correct index
      const mobileSlider = document.querySelector(
        ".custom-product-images-mobile-slider .galmain"
      );
      if (mobileSlider && mobileSlider.contains(image)) {
        const slides = document.querySelectorAll(
          ".custom-product-images-mobile-slider .cpim-slide"
        );
        correctIndex = Array.from(slides).indexOf(image);
      }

      setTimeout(() => {
        initializeSwipers(correctIndex);
      }, 50);
    });
  });

  // Close lightbox on button click
  closeButton.addEventListener("click", function () {
    lightbox.style.opacity = 0;
    setTimeout(() => {
      lightbox.style.display = "none";
      enableScroll();
    }, 300);
  });

  // Close lightbox when Escape key is pressed
  document.addEventListener("keydown", function (event) {
    if (event.key === "Escape") {
      lightbox.style.opacity = 0;
      setTimeout(() => {
        lightbox.style.display = "none";
        enableScroll();
      }, 300);
    }
  });
}

function customVariantPicker() {
  // console.log('Variant Details', variantDetails);

  const variantPicker = document.querySelector(".fealy-variant-picker");
  const variantDisplay = document.querySelector(".variant-option-name span");
  const variantDiscountDisplay = document.querySelector(
    ".variant-option-name-discount"
  ); // Element for price difference
  const mediaGallery = document.querySelector(
    ".custom-media-gallery__v2__images"
  ); // Desktop
  const mobileSlider = document.querySelector(
    ".custom-product-images-mobile-slider .slides"
  ); // Mobile

  // Sticky add-to-cart elements
  const stickyImage = document.querySelector(
    "#custom-sticky-add-to-cart .product-info__image img"
  );
  const stickyComparePrice = document.querySelector(
    "#custom-sticky-add-to-cart .compare-price"
  );
  const stickyRetailPrice = document.querySelector(
    "#custom-sticky-add-to-cart .retail-price"
  );
  const stickyVariantIdInput = document.querySelector(
    "#custom-sticky-add-to-cart .product-variant-id"
  );

  // Mobile custom price elements
  const mobileComparePrice = document.querySelector(
    ".custom-price-mobile .custom-price__compare"
  );
  const mobileRetailPrice = document.querySelector(
    ".custom-price-mobile .custom-price__price"
  );

  if (!variantPicker || !mediaGallery || !mobileSlider) {
    return;
  }

  if (!variantDetails || !Array.isArray(variantDetails)) {
    return;
  }

  // Get the price of the first variant (used as base price for comparison)
  const baseVariant = variantDetails[0];
  const basePrice = baseVariant ? baseVariant.variantPrice / 100 : 0; // Convert cents to euros

  function updateVariantDisplay() {
    const selectedInput = document.querySelector(
      ".swatch-input__input:checked"
    );

    // console.log('Selected Variant', selectedInput);

    if (selectedInput) {
      const selectedValue = selectedInput.value;
      if (variantDisplay) {
        variantDisplay.textContent = selectedValue;
      }

      const selectedVariant = variantDetails.find(
        (variant) => variant.variantName === selectedValue
      );
      const variantImages = selectedVariant ? selectedVariant.images : [];

      updateMediaGallery(
        mediaGallery,
        variantImages.length > 0 ? variantImages : []
      );
      updateMediaGallery(
        mobileSlider,
        variantImages.length > 0 ? variantImages : []
      );

      // Update Lightbox Images
      updateLightboxImages(variantImages.length > 0 ? variantImages : []);

      // Update Sticky Image
      if (stickyImage) {
        if (selectedVariant?.variantImage) {
          stickyImage.src =
            selectedVariant.variantImage.url || selectedVariant.variantImage;
        }
      }

      // Update Sticky Compare Price
      if (stickyComparePrice) {
        stickyComparePrice.textContent = selectedVariant?.variantCompare
          ? (selectedVariant.variantCompare / 100).toFixed(2)
          : "";
      }

      // Update Sticky Retail Price
      if (stickyRetailPrice) {
        stickyRetailPrice.textContent = (
          selectedVariant?.variantPrice / 100
        ).toFixed(2);
      }

      // Update Sticky Variant ID Input
      if (stickyVariantIdInput) {
        stickyVariantIdInput.value = selectedVariant?.variantId || "";
      }

      // Update Mobile Compare Price
      if (mobileComparePrice) {
        mobileComparePrice.textContent = selectedVariant?.variantCompare
          ? (selectedVariant.variantCompare / 100).toFixed(2)
          : "";
      }

      // Update Mobile Retail Price
      if (mobileRetailPrice) {
        mobileRetailPrice.textContent = (
          selectedVariant?.variantPrice / 100
        ).toFixed(2);
      }

      if (variantDiscountDisplay && selectedVariant) {
        const selectedPrice = selectedVariant.variantPrice / 100;
        const priceDifference = selectedPrice - basePrice;

        const truncated = Math.trunc(priceDifference * 100) / 100;

        variantDiscountDisplay.textContent =
          truncated >= 0 ? `+${truncated}` : `${truncated}`;
      }
    }
  }

  function updateMediaGallery(container, images) {
    const imageElements = container.querySelectorAll("img");

    images.forEach((image, index) => {
      if (imageElements[index]) {
        let rawUrl = image.url || image;

        // Remove _large
        rawUrl = rawUrl.replace("_large", "");

        // Remove existing &width=
        rawUrl = rawUrl.replace(/([?&])width=\d+/, "");

        // Append width=2048
        if (!rawUrl.includes("?")) {
          rawUrl += "?width=2048";
        } else {
          rawUrl += "&width=2048";
        }

        imageElements[index].src = rawUrl;
        imageElements[index].setAttribute("width", "2048");
      }
    });
  }

  function updateLightboxImages(images) {
    const lightboxSlides = document.querySelectorAll(
      ".swiper-zoom-container img"
    );
    const thumbnailSlides = document.querySelectorAll(
      ".swiper-image-container img"
    );

    if (!lightboxSlides.length || !thumbnailSlides.length) return;

    lightboxSlides.forEach((img, index) => {
      if (images[index]) {
        let rawUrl = images[index].url || images[index];

        // Remove _large
        rawUrl = rawUrl.replace("_large", "");

        // Remove existing &width= parameters
        rawUrl = rawUrl.replace(/([?&])width=\d+/, "");

        // Append width=600, 1200, and 1800 for srcset
        img.src = rawUrl;
        img.srcset = `${rawUrl}&width=600 600w, ${rawUrl}&width=1200 1200w, ${rawUrl}&width=1800 1800w`;
      }
    });

    thumbnailSlides.forEach((img, index) => {
      if (images[index]) {
        let rawUrl = images[index].url || images[index];

        // Remove _large
        rawUrl = rawUrl.replace("_large", "");

        // Remove existing &width= parameters
        rawUrl = rawUrl.replace(/([?&])width=\d+/, "");

        // Append width=400 for thumbnails
        img.src = `${rawUrl}&width=400`;
      }
    });
  }

  // Run on page load
  updateVariantDisplay();

  document.body.addEventListener("change", function (event) {
    if (event.target.matches(".swatch-input__input")) {
      updateVariantDisplay();
    }
  });
}

// ✅ Watch for late loading of the banner
const observer = new MutationObserver(() => {
  let banner = document.querySelector(".shopify-pc__banner__wrapper");
  if (banner) {
    observer.disconnect(); // Stop observing after finding the banner
    customCookieBanner(); // Run the script
  }
});

observer.observe(document.body, { childList: true, subtree: true });

function globalDeliveryPickerAndAddonsListPrices() {

  // -----------------------
  // Global price variables
  // -----------------------
  window.selectedVariantPrice = 0;        // main variant price
  window.selectedVariantComparePrice = 0; // main variant compare price
  window.selectedAddonsPrices = {};       // { variantId: {price, comparePrice} }

  // Helper: parse price text to number
  function parsePrice(text) {
    if (!text) return 0;
    return parseFloat(text.trim().replace('.', '').replace(',', '.'));
  }

  // -----------------------
  // Handle main product variants
  // -----------------------
  function updateMainVariantPrice(container) {
    const checkedInput = container.querySelector('input[type="radio"]:checked');
    if (!checkedInput) return;

    const label = container.querySelector(`label[for="${checkedInput.id}"]`);
    if (!label) return;

    const priceEl = label.querySelector('.variant-price-current');
    const compareEl = label.querySelector('.variant-price-compare');

    window.selectedVariantPrice = parsePrice(priceEl ? priceEl.textContent : '0');
    window.selectedVariantComparePrice = parsePrice(compareEl ? compareEl.textContent : priceEl ? priceEl.textContent : '0');

    // console.log('Main Variant Price:', window.selectedVariantPrice, 'Compare:', window.selectedVariantComparePrice);
    updateDisplayedPrice();
  }

  // Initialize for all variant-selects on page
  const variantSelectContainers = document.querySelectorAll('variant-selects');
  variantSelectContainers.forEach(container => {
    // Initial update
    updateMainVariantPrice(container);

    // Update on change
    const radios = container.querySelectorAll('input[type="radio"]');
    radios.forEach(radio => {
      radio.addEventListener('change', () => updateMainVariantPrice(container));
    });
  });

  // -----------------------
  // Handle add-on checkboxes
  // -----------------------
  const addonCheckboxes = document.querySelectorAll('.custom-addons-list-item input[type="checkbox"]');

  addonCheckboxes.forEach(checkbox => {
    checkbox.addEventListener('change', () => {
      const variantId = parseInt(checkbox.dataset.variantId);
      const item = checkbox.closest('.custom-addons-list-item');
      const priceEl = item.querySelector('.custom-addons-list-item-price-current');
      const compareEl = item.querySelector('.custom-addons-list-item-price-compare');
      const label = checkbox.nextElementSibling;

      const price = parsePrice(priceEl ? priceEl.textContent : '0');
      const comparePrice = parsePrice(compareEl ? compareEl.textContent : priceEl ? priceEl.textContent : '0');

      if (checkbox.checked) {
        label.textContent = 'Toegevoegd';
        window.selectedAddonsPrices[variantId] = { price, comparePrice };
      } else {
        label.textContent = 'Voeg Toe +';
        delete window.selectedAddonsPrices[variantId];
      }

      // console.log('Selected Add-ons Prices:', window.selectedAddonsPrices);
      updateDisplayedPrice();
    });
  });

  // -----------------------
  // Handle "1-2 werkdagen" delivery option
  // -----------------------
  const deliveryOptions = document.querySelectorAll('input[name="Kies je levertijd"]');
  const addonBlock1 = document.getElementById('custom-addons-list-addonslist1');
  const addonBlock2 = document.getElementById('custom-addons-list-addonslist2');

  // Make sure you have these defined separately
  const addonCheckboxes1 = addonBlock1 ? addonBlock1.querySelectorAll('input[type="checkbox"]') : [];
  const addonCheckboxes2 = addonBlock2 ? addonBlock2.querySelectorAll('input[type="checkbox"]') : [];

  function resetAddons(checkboxes) {
    checkboxes.forEach(checkbox => {
      checkbox.checked = false;

      const label = checkbox.nextElementSibling;
      const wrapper = checkbox
        .closest('.custom-addons-list-item')
        .querySelector('.custom-addons-list-item-button-wrapper');

      if (checkbox.disabled) {
        if (label) label.textContent = 'Uitverkocht';
        if (wrapper) wrapper.style.backgroundColor = '#2b274c';
      } else {
        if (label) label.textContent = 'Voeg Toe +';
        if (wrapper) wrapper.style.backgroundColor = '#2b274c';
      }
    });
  }

  function toggleAddonBlock() {
    if (deliveryOptions.length === 0) return;

    let option1Selected = false;
    let option2Selected = false;

    deliveryOptions.forEach((option, index) => {
      if (option.checked && index === 0) option1Selected = true; // Option 1
      if (option.checked && index === 1) option2Selected = true; // Option 2
    });

    if (addonBlock1) {
      addonBlock1.style.display = option1Selected ? 'none' : 'block';
      if (option1Selected) resetAddons(addonCheckboxes1);
    }

    if (addonBlock2) {
      addonBlock2.style.display = option2Selected ? 'none' : 'block';
      if (option2Selected) resetAddons(addonCheckboxes2);
    }

    // Clear global arrays if needed (you can separate for each list if required)
    if (option1Selected) {
      window.selectedAddonsPrices = {};
      window.selectedProductAddons = [];
    }
    if (option2Selected) {
      window.selectedAddonsPrices2 = {};
      window.selectedProductAddons2 = [];
    }

    if (typeof updateDisplayedPrice === 'function') updateDisplayedPrice();
  }

  // Initial check
  toggleAddonBlock();

  // Update on delivery change
  deliveryOptions.forEach(option => option.addEventListener('change', toggleAddonBlock));
}

/* ==================== Cart drawer checkout guard (pcd-guard v3, asset copy) ====================
   Safety net: identical to the inline definition in snippets/cart-drawer.liquid.
   Exists here so pages served from Shopify's HTML page cache (which predate the
   inline script) still get a working checkout button - this asset is fetched
   fresh from the CDN even on cached HTML. Both copies are guarded, so whichever
   loads first wins and the other is a no-op. */
if (!window.pcdCheckoutGuard) {
            window.pcdCheckoutGuard = function (btn) {
              var raw = btn.getAttribute('data-soldout-items') || '';
              var names = raw.split('||').filter(function (n) { return n.trim() !== ''; });
              if (names.length > 0) {
                var popup = document.getElementById('pcd-soldout-popup');
                var list = document.getElementById('pcd-soldout-popup-list');
                if (popup && list) {
                  list.innerHTML = '';
                  names.forEach(function (n) {
                    var li = document.createElement('li');
                    li.textContent = n;
                    list.appendChild(li);
                  });
                  popup.hidden = false;
                }
                return;
              }
              var lang = '';
              try {
                if (typeof Weglot !== 'undefined' && Weglot.getCurrentLang) lang = Weglot.getCurrentLang() || '';
              } catch (e) {}
              var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
              window.location.assign(root + 'checkout' + (lang ? '?locale=' + lang : ''));
            };
            window.pcdSoldoutClose = function () {
              var popup = document.getElementById('pcd-soldout-popup');
              if (popup) popup.hidden = true;
            };
          }
